<template>
  <section>
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-4 d-flex align-items-center">
          <div class="d-flex align-items-center">
            <div>
              <el-tooltip content="Back" placement="bottom">
                <base-button
                  type="neutral"
                  class="btn-icon-only"
                  @click="goToPreviousPage()"
                >
                  <i class="flaticon-left-1"></i>
                </base-button>
              </el-tooltip>
            </div>
            <div>
              <h1 class="title-view">
                Experience
              </h1>

              <div class="box-id">
                <span class="number-id"> {{ product.code }} </span>
                <span class="ml-2 mr-2">|</span>
                <div class="status-tab">
                  <div
                    class="badge-status text-status status-confirmed d-inline-flex align-items-center"
                    v-if="product.status === true"
                  >
                    Active
                  </div>

                  <div
                    class="badge-status text-status status-cancelled d-inline-flex align-items-center"
                    v-else
                  >
                    Inactive
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-8 text-right">
          <div class="box-buttons">
            <base-dropdown
              menu-on-right
              class="nav-item"
              tag="li"
              title-tag="a"
              title-classes="btn min-button btn-outline-neutral"
              title="Actions"
            >
              <base-button slot="title" type="none" class="p-0 min-button">
                <i class="flaticon-bold-menu-1"></i>
                <strong class="d-lg-block d-none">Actions</strong>
              </base-button>

              <div
                v-if="canUserCreate"
                class="dropdown-item"
                @click="duplicateProduct(productId)"
              >
                <i class="flaticon-copy"></i> Duplicate
              </div>

              <a
                :href="`/experiences/rhomtrip/web-preview/${productId}`"
                class="dropdown-item"
                target="_blank"
              >
                <i class="flaticon-visualization"></i> Web Preview
              </a>

              <div
                v-if="canUserCreate"
                class="dropdown-item"
                @click="goToNewProduct()"
              >
                <i class="flaticon-plus"></i> New experience
              </div>
            </base-dropdown>

            <base-button
              type="outline-neutral"
              class="min-button no-mb ml-2"
              v-if="mode === 'edit'"
              @click="mode = 'view'"
            >
              <i class="flaticon-view-1 icon-no-margin"></i>
              <strong class="d-lg-block d-none">View</strong>
            </base-button>

            <base-button
              type="outline-neutral"
              class="min-button no-mb ml-2"
              v-if="mode === 'view' && canUserUpdate"
              @click="mode = 'edit'"
            >
              <i class="flaticon-pencil icon-no-margin"></i>
              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>

            <base-button
              type="primary"
              class="min-button no-mb ml-2"
              @click="saveProduct()"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid ">
      <div v-if="mode === 'view'" class="profile">
        <div class="card">
          <h2 class="subtitle mb-1">Name | Title</h2>
          <div class="data-block mb-0">
            <span class="content-block mb-2">{{ product.name }} </span>
          </div>
        </div>
      </div>
      <div v-else class="forms">
        <div class="card pb-3">
          <h2 class="subtitle">
            Name | Title
            <el-popover
              placement="bottom"
              trigger="hover"
              width="350"
              class="curp"
            >
              <span>
                It's the name that identifies the experience. This name is taken
                as the Meta Title of the experience. Must be unique.
                <br />
              </span>
              <div class="badge badge-primary" slot="reference">?</div>
            </el-popover>
          </h2>

          <div class="row">
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-2"
              v-bind:class="{
                'is-invalid': $v.product.name.$error
              }"
            >
              <el-input
                v-model="$v.product.name.$model"
                placeholder="Experience Name"
                id="experience_name"
                name="experience_name"
                @input="createProductName"
                tabindex="1"
                maxlength="160"
                type="textarea"
                :autosize="{ minRows: 1, maxRows: 2 }"
                show-word-limit
                autofocus
              >
              </el-input>

              <div
                v-if="$v.product.name.$error"
                class="invalid-feedback mb-0 mt--1"
              >
                {{ validationMessageForProductName($v.product.name) }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <tabs
        tabNavClasses="tabs-home justify-content-around tab-profiles"
        :value="tabActive"
        @changeTabActive="changeTabActive"
        type="primary"
      >
        <tab-pane
          class="tabs-home-content"
          id="Overview"
          title="Overview"
          ref="Overview"
        >
          <div class="row profile" v-if="mode === 'view'">
            <div class="col-xl-9 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="card">
                <div class="row">
                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Category</span>
                      <span class="content-block"
                        >{{ getProductType(product.type) }}
                      </span>
                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Multiple Vehicles </span>
                      <span class="content-block">{{
                        getMultipleFormat(product.show_options)
                      }}</span>
                    </div>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Pricing Method </span>
                      <span class="content-block">{{
                        getPricingMethod(product.pricing_method)
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card">
                <h2 class="subtitle mb-2">Parameters</h2>

                <div class="row">
                  <div
                    class="col-xl-3 col-lg-3 col-md-3 col-sm-5 col-12"
                    v-if="product.type == 'PRIVATE_TRANSFER'"
                  >
                    <div class="data-block">
                      <span class="title-block">Quote</span>
                      <span class="content-block"
                        >{{ getQuoteFormat(quote) }}
                      </span>
                    </div>
                  </div>

                  <div
                    class="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12"
                    v-if="product.type == 'PRIVATE_TRANSFER'"
                  >
                    <div class="data-block">
                      <span class="title-block">Type Transfer</span>
                      <span class="content-block"
                        >{{ getBookingType(product.transfer.type) }}
                      </span>
                    </div>
                  </div>

                  <div
                    class="col-xl-2 col-lg-3 col-md-3 col-sm-3 col-12"
                    v-if="product.type == 'TOUR'"
                  >
                    <div class="data-block">
                      <span class="title-block">Quote</span>
                      <span class="content-block"
                        >{{ getQuoteFormat(quote) }}
                      </span>
                    </div>
                  </div>

                  <div
                    class="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12"
                    v-if="product.type == 'TOUR'"
                  >
                    <div class="data-block">
                      <span class="title-block">Type Transfer</span>
                      <span class="content-block">Hourly </span>
                    </div>
                  </div>

                  <div
                    class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12"
                    v-if="quote === 'AREA'"
                  >
                    <div class="data-block">
                      <span class="title-block">Destination</span>
                      <span class="content-block"
                        >{{ product.branch.name }}
                      </span>
                    </div>
                  </div>

                  <div
                    class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
                    v-if="product.from.address"
                  >
                    <div class="data-block">
                      <span class="title-block">From</span>
                      <span class="content-block"
                        >{{ product.from.address }}
                      </span>
                    </div>
                  </div>

                  <div
                    class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
                    v-if="product.to.address"
                  >
                    <div class="data-block">
                      <span class="title-block">To</span>
                      <span class="content-block"
                        >{{ product.to.address }}
                      </span>
                    </div>
                  </div>
                  <div
                    class="col-xl-3 col-lg-6 col-md-12 col-sm-12 col-12"
                    v-if="product.type == 'TOUR'"
                  >
                    <div class="data-block">
                      <span class="title-block">Hours</span>
                      <span class="content-block"
                        >{{ product.duration.value }} Hours</span
                      >
                    </div>
                  </div>
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                    <div class="data-block">
                      <span class="title-block">Vehicle Type</span>

                      <div class="box-img-card">
                        <div class="content ">
                          <span class="capitalize hide-data title fw-100">
                            {{ formatCategory(product.service.category) }}
                          </span>

                          <span class="hide-data subtitle-1">{{
                            product.service.vehicle.name
                          }}</span>
                          <span class="hide-data subtitle-2">{{
                            formatVehicleType(product.service.vehicle.type)
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-4 col-lg-6 col-md-4 col-sm-4 col-12">
                    <div class="data-block">
                      <span class="title-block">Area</span>
                      <span class="content-block"
                        >{{ product.area.name }}
                      </span>
                    </div>
                  </div>
                  <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6">
                    <div class="data-block">
                      <span class="title-block">N° Passengers</span>
                      <span class="content-block"
                        >{{ product.passengers.maximum }}
                      </span>
                    </div>
                  </div>

                  <div class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6">
                    <div class="data-block">
                      <span class="title-block">N° Bags</span>
                      <span class="content-block"
                        >{{ product.bags.maximum }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card pt-4 ">
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Availability</span>
                      <span class="content-block"
                        >{{
                          getAvailabilityTypeFormat(product.availability.type)
                        }}
                      </span>
                    </div>
                  </div>

                  <div
                    v-if="
                      product.availability.type === 'BLACKOUT' ||
                        (product.availability.type === 'DEFAULT' &&
                          product.availability.value.length > 0)
                    "
                    class="col-12"
                  >
                    <div class="">
                      <b-table
                        hover
                        :items="product.availability.value"
                        :fields="fields"
                        responsive
                        selectable
                        sort-icon-left
                        show-empty
                        empty-filtered-text="There are no records matching your request"
                        empty-text="There are no records to show"
                      >
                        <template #cell(name)="data">
                          <span>{{ data.item.name }}</span>
                        </template>
                        <template #cell(from)="data">
                          <span>{{
                            getDateFormat(data.item.from, "DD-MMM-YYYY")
                          }}</span>
                        </template>

                        <template #cell(end)="data">
                          <span>{{
                            getDateFormat(data.item.end, "DD-MMM-YYYY")
                          }}</span>
                        </template>
                        <template #cell(status)="data">
                          <div
                            class="badge-status badge-success"
                            v-if="data.item.status"
                          >
                            <span>Active </span>
                          </div>

                          <div class="badge-status badge-danger" v-else>
                            <span>Inactive</span>
                          </div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="card pt-4"
                :class="{ 'pb-4': product.cutoff.type === 'UNRESTRICRED' }"
              >
                <div class="row">
                  <div class="col-xl-3 col-lg-5 col-md-6 col-sm-7 col-12">
                    <div class="data-block">
                      <span class="title-block">CutOff</span>
                      <span class="content-block"
                        >{{ getCutOffTypeFormat(product.cutoff.type) }}
                      </span>
                    </div>
                  </div>

                  <div
                    v-if="
                      product.cutoff.type === 'MINIMUM' ||
                        product.cutoff.type === 'DEFAULT'
                    "
                    class="col-xl-3 col-lg-3 col-md-4 col-sm-5 col-12"
                  >
                    <div class="data-block">
                      <span class="title-block">Minimum CutOff</span>
                      <span class="content-block"
                        >{{ product.cutoff.value }} Hours
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card p-not-action" v-if="product.keyDetails">
                <h2 class="subtitle mb-3">Key Details</h2>
                <div>
                  <div class="data-block">
                    <span class="content-block">
                      {{ product.keyDetails }}
                    </span>
                  </div>
                </div>
              </div>

              <div
                class="card p-not-action"
                v-if="product.cancellation_policy.length"
              >
                <h2 class="subtitle">
                  Cancellation Policy
                </h2>
                <div class="row">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-3"
                  >
                    <ul class="list-preview">
                      <li
                        v-for="(item, index) in product.cancellation_policy"
                        :key="index"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="card p-not-action " v-if="product.termsConditions">
                <h2 class="subtitle mb-3">Terms and Conditions</h2>
                <div>
                  <div class="data-block">
                    <span class="content-block">
                      {{ product.termsConditions }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <div class="card">
                    <h2 class="subtitle">Price</h2>
                    <div class="row">
                      <div class="col-xl-12 col-lg-4 col-md-4 col-sm-4 col-12">
                        <div class="data-block">
                          <span class="title-block">Time Zone</span>
                          <span class="content-block"
                            >{{ product.time_zone }}
                          </span>
                        </div>
                      </div>

                      <div class="col-xl-12 col-lg-4 col-md-4 col-sm-4 col-12">
                        <div class="data-block">
                          <span class="title-block">Currency</span>
                          <span class="content-block"
                            >{{ product.currency.code }}
                          </span>
                        </div>
                      </div>

                      <div class="col-xl-12 col-lg-4 col-md-4 col-sm-4 col-12">
                        <div class="data-block">
                          <span class="title-block">Price</span>
                          <span class="content-block"
                            >{{ product.currency.symbol }}
                            {{ product.pricing.amount }}
                            {{ product.currency.code }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row forms" v-else>
            <div class="col-xl-9 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="card pb-0">
                <div class="row pt-2">
                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 option-transfers pb-3"
                  >
                    <label class="title-label"
                      ><span class="markrequired">*</span>
                      Type
                      <el-popover
                        placement="bottom"
                        trigger="hover"
                        width="350"
                        class="curp"
                      >
                        <span>
                          <ul class="p-2">
                            <li class="mb-2">
                              <strong>- Private Transfers: </strong>Packages
                              that provide private transportation services from
                              airports to hotels or other locations.
                            </li>

                            <li>
                              <strong>- Tours: </strong>Packages that combine
                              airport transfers with guided tours of popular
                              destinations or attractions.
                            </li>
                            <!-- <li class="mb-2">
                              <strong>- Events: </strong>Packages that include
                              airport transfers for specific events, such as
                              concerts, sports games, conferences, etc.
                            </li>
                            <li>
                              <strong>- Attractions: </strong>Packages that
                              include airport transfers and admission to popular
                              tourist attractions or landmarks.
                            </li> -->
                          </ul>
                        </span>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </label>

                    <b-form-radio-group
                      id="btn-radios-1"
                      v-model="$v.product.type.$model"
                      :options="productTypes"
                      name="product_types"
                      value-field="value"
                      text-field="label"
                      button-variant="group-neutral"
                      tabindex="3"
                      buttons
                      class="buttons-type pc-0"
                      v-bind:class="{
                        'is-invalid': $v.product.type.$error
                      }"
                      @change="selectProductType"
                    ></b-form-radio-group>
                    <small
                      class="invalid-feedback"
                      v-if="$v.product.type.$error"
                      >Select a experience Type</small
                    >
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pb-3">
                    <label class="title-label"
                      ><span class="markrequired">*</span>Multiple Options
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <span>
                          <ul class="p-2">
                            <li class="mb-2">
                              Activate this option if you require more vehicle
                              options to be shown, additional vehicle details
                              added to the quote.
                            </li>

                            <li>
                              <strong>Note: </strong>If the Pricing Method is
                              set to <strong>Fixed</strong>, you will not be
                              able to configure multiple options for the
                              product.
                            </li>
                          </ul>
                        </span>

                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover></label
                    >
                    <base-switch
                      class="sw-md mt-3 ml-3"
                      v-model="product.show_options"
                    ></base-switch>
                  </div>

                  <div
                    class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 option-transfers pb-3"
                  >
                    <label class="title-label"
                      ><span class="markrequired">*</span>Pricing Method
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <span>
                          <ul class="p-2">
                            <li class="mb-2">
                              <strong>- Fixed: </strong>The price of the product
                              will be the one previously defined.
                            </li>

                            <li>
                              <strong>- Computed: </strong>The app will
                              calculate the price using an assigned rate or
                              other factor and then display the calculated
                              price.
                            </li>
                          </ul>
                        </span>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover></label
                    >

                    <b-form-radio-group
                      id="radio-quote"
                      name="radio-quote"
                      buttons
                      button-variant="outline-neutral"
                      class="buttons-type pc-0"
                      v-model="product.pricing_method"
                      @change="changePricingMethod"
                    >
                      <b-form-radio value="FIXED">Fixed</b-form-radio>
                      <b-form-radio value="COMPUTED">Computed</b-form-radio>
                    </b-form-radio-group>
                  </div>

                  <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-12 pb-3">
                    <label class="title-label"
                      ><span class="markrequired">*</span>Active
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        class="curp"
                      >
                        <span>
                          <strong>Activate:</strong> When you've finished
                          editing your experience, you can click Activate to
                          make it bookable and available to be consumed via API.
                        </span>

                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover></label
                    >
                    <base-switch
                      class="sw-md mt-3 ml-3"
                      v-model="product.status"
                    ></base-switch>
                  </div>
                </div>
              </div>

              <div class="card">
                <h2 class="subtitle mb-3">Parameters</h2>
                <div class="row">
                  <div
                    class="col-xl-3 col-lg-3 col-md-3 col-sm-5 col-12 option-transfers"
                    v-if="product.type == 'PRIVATE_TRANSFER'"
                  >
                    <label class="title-label"
                      ><span class="markrequired">*</span>Quote</label
                    >
                    <b-form-group v-slot="radioquote" class="">
                      <b-form-radio-group
                        v-model="quote"
                        :aria-describedby="radioquote"
                        id="radio-quote"
                        name="radio-quote"
                        buttons
                        @change="selectTypeQuote"
                        button-variant="outline-neutral pc-1"
                        tabindex="4"
                        class="buttons-type "
                      >
                        <b-form-radio value="AREA">Area</b-form-radio>
                        <b-form-radio value="POINTS">From & To</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-7 col-12 "
                    v-bind:class="{
                      'is-invalid': $v.product.transfer.type.$error
                    }"
                    v-if="product.type == 'PRIVATE_TRANSFER'"
                  >
                    <label class="title-label">Type Transfer</label>
                    <div class="option-transfers ">
                      <WSelect
                        placeholder="Reservation Type"
                        v-model="$v.product.transfer.type.$model"
                        filterable
                        id="typeTransfer"
                        label="Type Transfer"
                        markrequired
                      >
                        <el-option
                          v-for="option in transfersOptions"
                          :value="option.value"
                          :label="option.label"
                          :key="option.label"
                        ></el-option>
                      </WSelect>
                    </div>
                  </div>

                  <div
                    class="col-xl-2 col-lg-3 col-md-3 col-sm-3 col-12"
                    v-if="product.type == 'TOUR'"
                  >
                    <div class="data-block">
                      <span class="title-block">Quote</span>
                      <span class="content-block"
                        >{{ getQuoteFormat(quote) }}
                      </span>
                    </div>
                  </div>

                  <div
                    class="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12"
                    v-if="product.type == 'TOUR'"
                  >
                    <div class="data-block">
                      <span class="title-block">Type Transfer</span>
                      <span class="content-block">Hourly </span>
                    </div>
                  </div>

                  <div
                    class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12"
                    v-show="quote === 'AREA'"
                  >
                    <WSelect
                      v-bind:class="{
                        'is-invalid': $v.product.branch.ref.$error
                      }"
                      v-model="$v.product.branch.ref.$model"
                      label="Destination"
                      placeholder="Enter a Destination"
                      id="branch"
                      name="branch"
                      remote
                      reserve-keyword
                      :remote-method="getRatesWithTheDestination"
                      @change="selectDestination"
                      tabindex="5"
                      filterable
                      clearable
                      markrequired
                      :error="
                        $v.product.branch.ref.$error
                          ? 'Select a Destination'
                          : ''
                      "
                      tooltip
                      contentTooltip="Select the city/area where the experience will be created and performed."
                    >
                      <el-option
                        v-for="(item, index) in destinations"
                        :value="item._id"
                        :label="`${item.name} - ${item.supplier.name}`"
                        :key="`${index}`"
                      >
                        <span class="hide-data-inline coin-left">{{
                          item.name
                        }}</span>
                        <span class="hide-data-inline coin-right">{{
                          item.supplier.name
                        }}</span>
                      </el-option>
                    </WSelect>
                  </div>

                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <WSelect
                      label="From"
                      placeholder="Address or Hotel Name"
                      v-bind:class="{
                        'is-invalid': $v.product.from.address.$error
                      }"
                      id="from"
                      name="from"
                      filterable
                      remote
                      reserve-keyword
                      :remote-method="getLocationFrom"
                      :loading="loading"
                      v-model="$v.product.from.address.$model"
                      @change="selectFrom"
                      tabindex="5"
                      ref="from"
                      :focusact="true"
                      no-data-text="Search by destination or landmark"
                      clearable
                      allText
                      markrequired
                      :error="
                        $v.product.from.address.$error
                          ? 'Enter address from'
                          : ''
                      "
                    >
                      <el-option
                        v-for="(location, index) in optionsFrom"
                        class
                        :value="location.select"
                        :label="location.select"
                        :key="`${index}`"
                      >
                        <div class="d-flex align-items-center">
                          <i :class="getIcon(location.type)"></i>
                          <span class="ml-3">
                            {{ location.select }}
                          </span>
                        </div>
                      </el-option>
                    </WSelect>
                  </div>

                  <div
                    class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
                    v-if="product.type == 'PRIVATE_TRANSFER'"
                  >
                    <WSelect
                      label="To"
                      placeholder="Address or Hotel Name"
                      v-bind:class="{
                        'is-invalid': $v.product.to.address.$error
                      }"
                      id="to"
                      name="to"
                      filterable
                      remote
                      reserve-keyword
                      :remote-method="getLocationTo"
                      :loading="loading"
                      v-model="$v.product.to.address.$model"
                      @change="selectTo"
                      tabindex="6"
                      ref="to"
                      :focusact="true"
                      no-data-text="Search by destination or landmark"
                      clearable
                      allText
                      :markrequired="quote === 'POINTS'"
                      :error="
                        $v.product.to.address.$error ? 'Enter address to' : ''
                      "
                    >
                      <el-option
                        v-for="(location, index) in optionsTo"
                        :value="location.select"
                        :label="location.select"
                        :key="index"
                      >
                        <div class="d-flex align-items-center">
                          <i :class="getIcon(location.type)"></i>
                          <span class="ml-3">
                            {{ location.select }}
                          </span>
                        </div>
                      </el-option>
                    </WSelect>
                  </div>

                  <div
                    class="col-xl-4 col-lg-6 col-md-12 col-sm-12 col-12"
                    v-if="product.type == 'TOUR'"
                  >
                    <WSelect
                      placeholder="Select Hourly"
                      v-model.number="$v.product.duration.value.$model"
                      id="number_hourly"
                      name="number_hourly"
                      label="Hours"
                      :error="
                        $v.product.duration.value.$error ? 'Select Hours' : ''
                      "
                      @change="selectHourly"
                    >
                      <el-option
                        v-for="number in minimumSelect"
                        :value="number"
                        :label="number"
                        :key="number"
                      ></el-option>
                      <template slot="append">Hours</template>
                    </WSelect>
                  </div>

                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                    <WSelect
                      label="Vehicle Type"
                      id="vehicle_type"
                      name="vehicle_type"
                      placeholder="Vehicle Type"
                      v-model="$v.product.service.ref.$model"
                      @change="selectServicesType"
                      tabindexn="3"
                      markrequired
                      :error="
                        $v.product.service.ref.$error
                          ? 'Select a Vehicle Type'
                          : ''
                      "
                    >
                      <el-option
                        v-for="(item, index) in services"
                        :value="item._id"
                        :label="`${item.vehicle.name}`"
                        :key="`${index}`"
                      >
                        <span class="coin-left">{{ item.vehicle.name }} </span>
                        <span class="coin-right">
                          {{ getCategoryFormat(item.vehicle.category) }}
                        </span>
                      </el-option>
                    </WSelect>
                  </div>

                  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                    <WSelect
                      v-model="$v.product.area.ref.$model"
                      label="Area"
                      placeholder="Enter a Area"
                      id="area"
                      name="area"
                      tabindex="8"
                      @change="selectArea"
                      filterable
                      markrequired
                      :error="
                        $v.product.area.ref.$error ? 'Select an Area' : ''
                      "
                      class="input-appred"
                    >
                      <el-option
                        v-for="(item, index) in areas"
                        :value="item._id"
                        :label="item.code"
                        :key="`${index}`"
                      >
                        <div class="row">
                          <div class="col-6 align-self-center">
                            <span class="d-block"
                              ><strong>{{ item.code }}</strong>
                            </span>
                          </div>

                          <div class="col-6 align-self-center text-right">
                            <span
                              class="d-block"
                              v-if="product.type !== 'TOUR'"
                            >
                              {{ product.currency.symbol }} {{ item.price }}
                              {{ product.currency.code }}</span
                            >
                          </div>
                          <div class="col-12">
                            <span class="d-block mt-1 text-null">{{
                              item.description
                            }}</span>
                          </div>
                        </div>
                      </el-option>
                      <template slot="suffix" v-if="$v.product.area.ref.$model">
                        <el-popover placement="top" trigger="hover" width="300">
                          <p class="content-tooltip">
                            {{
                              getDescriptionByAreaId($v.product.area.ref.$model)
                            }}
                          </p>
                          <div
                            class="badge badge-primary badge-suffix"
                            slot="reference"
                          >
                            ?
                          </div>
                        </el-popover>
                      </template>
                    </WSelect>
                  </div>

                  <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6">
                    <BaseNumberInput
                      class
                      v-model.number="$v.product.passengers.maximum.$model"
                      mode="integer"
                      label="N° Passengers"
                      placeholder="N° Passengers"
                      id="passengers"
                      name="passengers"
                      tabindex="9"
                      :error="
                        !$v.product.passengers.maximum.numeric ||
                        $v.product.passengers.maximum.$error
                          ? `Enter a N° Passengers`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6">
                    <BaseNumberInput
                      class
                      v-model.number="$v.product.bags.maximum.$model"
                      mode="integer"
                      label="N° Bags"
                      placeholder="N° Bags"
                      id="bags"
                      name="bags"
                      tabindex="10"
                      :error="
                        !$v.product.bags.maximum.numeric ||
                        $v.product.bags.maximum.$error
                          ? `Enter a N° Bags`
                          : ''
                      "
                    />
                  </div>
                </div>
              </div>

              <div class="card pt-4 pb-4">
                <h2 class="subtitle">
                  Availability
                  <el-popover
                    placement="bottom"
                    trigger="hover"
                    width="350"
                    class="curp"
                  >
                    <span>
                      <ul class="p-2">
                        <li class="mb-2">
                          <strong>- Default:</strong> Takes Blackout event if
                          any in the "Extras section" for the rate selected in
                          the experience.
                        </li>
                        <li class="mb-2">
                          <strong>- Blackout Dates:</strong> You can add an
                          event such as Blackout from here.
                        </li>
                        <li>
                          <strong>- No Restriction:</strong> The experience is
                          always available and w/out any restrictions.
                        </li>
                      </ul>
                    </span>

                    <div class="badge badge-primary" slot="reference">?</div>
                  </el-popover>
                </h2>
                <div class="row">
                  <div
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 option-transfers mb-3"
                  >
                    <b-form-radio-group
                      id="btn-radios-1"
                      v-model="$v.product.availability.type.$model"
                      :options="availability"
                      name="availability"
                      @change="selectAvailability"
                      value-field="value"
                      text-field="label"
                      button-variant="group-neutral pc-1"
                      tabindex="11"
                      buttons
                      class="buttons-type"
                      v-bind:class="{
                        'is-invalid': $v.product.availability.type.$error
                      }"
                    ></b-form-radio-group>
                  </div>

                  <div
                    v-if="
                      product.availability.type === 'BLACKOUT' ||
                        (product.availability.type === 'DEFAULT' &&
                          product.availability.value.length > 0)
                    "
                    class="col-12"
                  >
                    <div class="row">
                      <div class="col-xl-6 align-self-center">
                        <h4 class="subtitle">Blackout Dates</h4>
                      </div>
                      <div class="col-xl-6 text-right align-self-center">
                        <base-button
                          type="outline-neutral"
                          class="btn-min"
                          @click="addNewBlackout()"
                          tabindex="14"
                        >
                          <i class="flaticon-plus"></i>Add Blackout Date
                        </base-button>
                      </div>
                    </div>

                    <div class="card p-0">
                      <div class="">
                        <b-table
                          hover
                          :items="product.availability.value"
                          :fields="fields"
                          responsive
                          selectable
                          sort-icon-left
                          show-empty
                          empty-filtered-text="There are no records matching your request"
                          empty-text="There are no records to show"
                        >
                          <template #cell(name)="data">
                            <span>{{ data.item.name }}</span>
                          </template>
                          <template #cell(from)="data">
                            <span>{{
                              getDateFormat(data.item.from, "DD-MMM-YYYY")
                            }}</span>
                          </template>

                          <template #cell(end)="data">
                            <span>{{
                              getDateFormat(data.item.end, "DD-MMM-YYYY")
                            }}</span>
                          </template>
                          <template #cell(status)="data">
                            <div
                              class="badge-status badge-success"
                              v-if="data.item.status"
                            >
                              <span>Active </span>
                            </div>

                            <div class="badge-status badge-danger" v-else>
                              <span>Inactive</span>
                            </div>
                          </template>

                          <template #cell(actions)="data">
                            <el-tooltip content="Edit" placement="bottom">
                              <span
                                class="icon-action"
                                @click="updateBlackout(data.index, data.item)"
                              >
                                <i class="flaticon-pencil"></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip
                              content="Change status"
                              placement="bottom"
                            >
                              <span
                                class="icon-action ml-2"
                                @click="
                                  changeStatusByIndex(
                                    data.index,
                                    !data.item.status
                                  )
                                "
                              >
                                <i class="flaticon-right-4 text-info"></i>
                              </span>
                            </el-tooltip>

                            <el-tooltip content="Remove" placement="bottom">
                              <span
                                class="icon-action text-danger ml-2"
                                @click="deleteBlackoutDate(data.index)"
                              >
                                <i class="flaticon-delete"></i>
                              </span>
                            </el-tooltip>
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>
                </div>

                <small
                  class="invalid-feedback"
                  v-if="$v.product.availability.value.$error"
                  >Enter minimum 1 item</small
                >
              </div>

              <div
                class="card pt-4"
                :class="{ 'pb-4': product.cutoff.type === 'UNRESTRICRED' }"
              >
                <h2 class="subtitle">
                  CutOff
                  <el-popover
                    placement="bottom"
                    trigger="hover"
                    width="350"
                    class="curp"
                  >
                    <span>
                      <ul class="p-2">
                        <li class="mb-2">
                          <strong>- Default:</strong> Takes whatever is selected
                          in the "Booking Cutoff" for the rate selected.
                        </li>
                        <li class="mb-2">
                          <strong>- Minimum:</strong> You can change the current
                          Cutoff as Blackout from here.
                        </li>
                        <li>
                          <strong>- No Restriction:</strong> The experience is
                          always available and w/out any restrictions.
                        </li>
                      </ul>
                    </span>
                    <div class="badge badge-primary" slot="reference">?</div>
                  </el-popover>
                </h2>
                <div class="row">
                  <div
                    class="col-xl-5 col-lg-4 col-md-6 col-sm-7 col-12 option-transfers mb-4"
                  >
                    <b-form-radio-group
                      id="btn-radios-1"
                      v-model="$v.product.cutoff.type.$model"
                      :options="cutOffOptios"
                      @change="selectCutoff"
                      name="radios-btn-default"
                      buttons
                      value-field="value"
                      text-field="label"
                      button-variant="group-neutral pc-1"
                      tabindex="12"
                      class="buttons-type"
                      v-bind:class="{
                        'is-invalid': $v.product.cutoff.type.$error
                      }"
                    ></b-form-radio-group>
                  </div>

                  <div
                    v-if="
                      product.cutoff.type === 'MINIMUM' ||
                        product.cutoff.type === 'DEFAULT'
                    "
                    class="col-xl-3 col-lg-3 col-md-3 col-sm-5 col-12"
                  >
                    <BaseNumberInput
                      v-model.number="$v.product.cutoff.value.$model"
                      mode="integer"
                      label="Minimum CutOff"
                      placeholder="setMinimum"
                      class="input-append with-append p-0"
                      id="setMinimum"
                      name="setMinimum"
                      tabindex="13"
                      :error="
                        !$v.product.cutoff.value.numeric ||
                        $v.product.cutoff.value.$error
                          ? `Set a Minimum`
                          : ''
                      "
                    >
                      <template slot="append">Hours</template>
                    </BaseNumberInput>
                  </div>
                </div>
              </div>

              <div class="card p-not-action">
                <div class="row forms ">
                  <div
                    class="col-12 mb-3 align-self-center"
                    v-bind:class="{
                      'is-invalid': $v.product.keyDetails.$error
                    }"
                  >
                    <h2 class="subtitle">Key Details</h2>

                    <el-input
                      v-model="$v.product.keyDetails.$model"
                      placeholder="Key Details"
                      id="keyDetails"
                      name="keyDetails"
                      maxlength="1500"
                      type="textarea"
                      :autosize="{ minRows: 5, maxRows: 10 }"
                      show-word-limit
                    >
                    </el-input>

                    <small
                      class="invalid-feedback"
                      v-if="
                        !$v.product.keyDetails.minLength ||
                        $v.product.keyDetails.$error
                          ? `Minimum ${$v.product.keyDetails.$params.minLength.min} and Maximum ${$v.product.keyDetails.$params.maxLength.max} letters.`
                          : ''
                      "
                      >Enter the Key Details</small
                    >
                  </div>
                </div>
              </div>

              <div class="card p-not-action">
                <h2 class="subtitle">
                  Cancellation Policy
                  <el-popover
                    placement="bottom"
                    trigger="hover"
                    width="350"
                    class="curp"
                  >
                    <div class="p-2">
                      <span>
                        Write the cancellation policies taking into account the
                        following points: <br />
                        <ul>
                          <li>- Cancellation Period</li>
                          <li>- Modification of Reservations</li>
                          <li>- No-Show Policy</li>
                          <li>- Refund Process</li>
                          <li>- Communication of Changes</li>
                        </ul>
                      </span>
                    </div>

                    <div class="badge badge-primary" slot="reference">?</div>
                  </el-popover>
                </h2>
                <div class="row">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-2"
                    v-bind:class="{
                      'is-invalid': $v.product.cancellation_policy.$error
                    }"
                  >
                    <div
                      class="row"
                      v-for="(item, index) in $v.cancellationPolicy.$each.$iter"
                      :key="index"
                    >
                      <div
                        class="col-xl-11 col-lg-11 col-md-11 col-sm-10 col-11"
                        v-bind:class="{
                          'is-invalid': item.message.$error
                        }"
                      >
                        <el-input
                          v-model="item.message.$model"
                          placeholder="Message"
                          id="message"
                          name="message"
                          tabindex="20"
                          maxlength="160"
                          type="textarea"
                          :autosize="{
                            minRows: 1,
                            maxRows: 2
                          }"
                          show-word-limit
                        />
                        <div
                          v-if="item.message.$error"
                          class="invalid-feedback"
                        >
                          {{
                            !item.message.minLength || item.message.$error
                              ? `Minimum ${item.message.$params.minLength.min} and Maximum ${item.message.$params.maxLenght.max} characters.`
                              : ""
                          }}
                        </div>
                      </div>

                      <div
                        class="col-xl-1 col-lg-1 col-md-1 col-sm-2 col-12 text-center align-self-center pl-0 "
                        v-if="!item.added.$model"
                      >
                        <base-button
                          type="outline-neutral "
                          class="btn-min"
                          @click="addCancellationPolicy(item.message, index)"
                        >
                          <i class="flaticon-plus"></i> Add
                        </base-button>
                      </div>

                      <div
                        class="col-xl-1 col-lg-1 col-md-1 col-sm-2 col-1 text-center align-self-center pl-0"
                        v-else
                      >
                        <base-button
                          type="link"
                          class="min-button px-0"
                          @click="deleteCancellationPolicy(index)"
                        >
                          <el-tooltip content="Remove" placement="bottom">
                            <span class="icon-action text-danger">
                              <i class="flaticon-cancel"></i>
                            </span>
                          </el-tooltip>
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card p-not-action">
                <div class="row forms ">
                  <div
                    class="col-12 mb-3 align-self-center"
                    v-bind:class="{
                      'is-invalid': $v.product.termsConditions.$error
                    }"
                  >
                    <h2 class="subtitle">Terms and Conditions</h2>

                    <el-input
                      v-model="$v.product.termsConditions.$model"
                      placeholder="Special Requirements"
                      id="termsconditions"
                      name="termsconditions"
                      maxlength="2100"
                      type="textarea"
                      :autosize="{ minRows: 5, maxRows: 10 }"
                      show-word-limit
                    >
                    </el-input>

                    <small
                      class="invalid-feedback"
                      v-if="
                        !$v.product.termsConditions.minLength ||
                        $v.product.termsConditions.$error
                          ? `Minimum ${$v.product.termsConditions.$params.minLength.min} and Maximum ${$v.product.termsConditions.$params.maxLength.max} letters.`
                          : ''
                      "
                      >Enter the Terms and Conditions</small
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="row">
                <div class="col-xl-12">
                  <div class="card">
                    <h2 class="subtitle mb-3">Price</h2>
                    <div class="row">
                      <div class="col-xl-12 col-lg-4 col-md-6 col-sm-6 col-12">
                        <WSelect
                          label="Time Zone"
                          id="time_zone"
                          name="time_zone"
                          placeholder="Time Zone"
                          v-model="product.time_zone"
                          disabled
                          tabindex="22"
                          markrequired
                          :error="
                            $v.product.time_zone.$error
                              ? 'Select a Time Zone'
                              : ''
                          "
                        >
                          <el-option
                            v-for="(item, index) in timeZones"
                            :value="item.value"
                            :label="item.label"
                            :key="`${index}`"
                          />
                        </WSelect>
                      </div>

                      <div class="col-xl-12 col-lg-4 col-md-6 col-sm-6 col-12">
                        <WSelect
                          placeholder="Currency"
                          v-model="$v.product.currency.code.$model"
                          id="product_pricing_currency"
                          name="product_pricing_currency"
                          label="Currency"
                          tabindex="24"
                          markrequired
                        >
                          <el-option
                            v-for="coin in coins"
                            :value="coin.code"
                            :label="coin.label"
                            :key="coin.code"
                          >
                            <span class="coin-left mr-2">{{ coin.label }}</span>
                            <span class="coin-right">{{ coin.symbol }}</span>
                          </el-option>
                        </WSelect>
                      </div>

                      <div class="col-xl-12 col-lg-4 col-md-6 col-sm-6 col-12">
                        <BaseNumberInput
                          v-model.number="$v.product.pricing.amount.$model"
                          label="Price"
                          placeholder="Price"
                          id="product_price"
                          name="product_price"
                          tabindex="23"
                          markrequired
                          class="input-append with-prepend"
                          :error="
                            $v.product.pricing.amount.$error
                              ? `Enter a Price`
                              : ''
                          "
                        >
                          <template slot="prepend">{{
                            product.currency.symbol
                          }}</template>
                          <template slot="append">{{
                            product.currency.code
                          }}</template>
                        </BaseNumberInput>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>

        <tab-pane
          class="tabs-home-content"
          id="Content"
          title="Content"
          ref="Content"
        >
          <div class="row profile" v-if="mode === 'view'">
            <div class="col-xl-9 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="card pb-4">
                <h2 class="subtitle mb-3">Description</h2>
                <div class="row">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="data-block">
                      <span class="title-block">Short Description</span>
                      <span class="content-block"
                        >{{ product.short_description }}
                      </span>
                    </div>
                  </div>

                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="data-block">
                      <span class="title-block">Description</span>
                      <span class="content-block" v-html="product.description">
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card pb-4" v-if="product.important_information">
                <h2 class="subtitle">
                  Important Information
                </h2>
                <div class="row">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-4 col-12 pb-2"
                  >
                    <ul class="list-preview">
                      <li
                        v-for="(item, index) in product.important_information"
                        :key="index"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="card pb-4" v-if="product.meeting_points">
                <h2 class="subtitle">
                  Meeting Point
                </h2>
                <div class="row">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-4 col-12 pb-2"
                  >
                    <ul class="list-preview">
                      <li
                        v-for="(item, index) in product.meeting_points"
                        :key="index"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div
                class="card pb-4"
                v-if="product.additional_information.length"
              >
                <h2 class="subtitle">
                  Additional Information
                </h2>

                <div class="row">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-2"
                  >
                    <ul class="list-preview">
                      <li
                        v-for="(item, index) in product.additional_information"
                        :key="index"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="card pb-4">
                <h2 class="subtitle">
                  Pictures
                </h2>

                <div class="box-drop col-xl-9">
                  <div class="images-box row justify-content-left mt-0">
                    <div
                      v-for="(image, index) in product.images"
                      :key="index"
                      class="image-container"
                    >
                      <div class="image-wrapper-1">
                        <img
                          v-lazy="image"
                          alt="Preview"
                          class="preview-image-2 curp"
                          @click="openBox(index)"
                        />
                      </div>
                    </div>

                    <LightBox
                      :media="imagesExperiences"
                      :showLightBox="showLightbox"
                      :startAt="currentImageIndex"
                      @close="showLightbox = false"
                      ref="lightbox"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="row">
                <div
                  class="col-xl-12 col-lg-4 col-md-4 col-sm-6 col-12 box-flex"
                >
                  <div class="card">
                    <h2 class="subtitle">
                      What's Included
                    </h2>
                    <div
                      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 check-expand"
                    >
                      <ul class="list-preview mb-3">
                        <li
                          class="capitalize"
                          v-for="(item, index) in product.inclusions"
                          :key="index"
                        >
                          {{ item }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div
                  class="col-xl-12 col-lg-4 col-md-4 col-sm-6 col-12 box-flex"
                >
                  <div class="card">
                    <h2 class="subtitle">
                      What's not Included
                    </h2>
                    <div
                      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 check-expand"
                    >
                      <ul class="list-preview mb-3">
                        <li
                          class="capitalize"
                          v-for="(item, index) in product.exclusions"
                          :key="index"
                        >
                          {{ item }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div
                  class="col-xl-12 col-lg-4 col-md-4 col-sm-6 col-12 box-flex"
                  v-if="product.tags > 1"
                >
                  <div class="card">
                    <h2 class="subtitle">
                      Tags
                    </h2>

                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <ul class="list-preview mb-3">
                        <li v-for="(item, index) in product.tags" :key="index">
                          {{ item.name }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row forms" v-else>
            <div class="col-xl-9 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="card pb-4">
                <h2 class="subtitle mb-3">Description</h2>
                <div class="row">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4"
                    v-bind:class="{
                      'is-invalid': $v.product.short_description.$error
                    }"
                  >
                    <label for="product_Description" class="title-label"
                      ><span class="markrequired">*</span>Short Description
                      <el-popover
                        placement="bottom"
                        trigger="hover"
                        width="350"
                        class="curp"
                      >
                        <span>
                          Add a short description of the experience.
                        </span>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </label>

                    <el-input
                      v-model="$v.product.short_description.$model"
                      placeholder="Experience short_description"
                      id="product_short_description"
                      name="product_short_description"
                      tabindex="15"
                      maxlength="160"
                      type="textarea"
                      :autosize="{ minRows: 1, maxRows: 2 }"
                      show-word-limit
                    >
                    </el-input>

                    <div
                      v-if="$v.product.short_description.$error"
                      class="invalid-feedback mb-0 mt--1"
                    >
                      {{
                        $v.product.short_description.$error
                          ? `Minimum ${$v.product.short_description.$params.minLength.min} and Maximum ${$v.product.short_description.$params.maxLenght.max} characters.`
                          : ""
                      }}
                    </div>
                  </div>

                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                    v-bind:class="{
                      'is-invalid': $v.product.description.$error
                    }"
                  >
                    <label
                      for="product_Description"
                      class="title-label-np"
                      v-bind:class="{
                        'is-invalid': $v.product.description.$error
                      }"
                      ><span class="markrequired">*</span>Description
                      <el-popover
                        placement="bottom"
                        trigger="hover"
                        width="350"
                        class="curp"
                      >
                        <span>
                          Add a description as it will be a part of the
                          experience information for OTA's and marketplace
                          resellers. This information will also be displayed in
                          the general view of the experience.
                        </span>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </label>
                    <vue-editor
                      v-model="$v.product.description.$model"
                      :editorToolbar="customToolbar"
                    ></vue-editor>

                    <div
                      v-if="$v.product.description.$error"
                      class="invalid-feedback mb-0 mt--1"
                    >
                      Minimum 160, maximum 1000 characters
                    </div>
                  </div>
                </div>
              </div>

              <div class="card pb-4">
                <h2 class="subtitle">
                  Important Information
                  <el-popover
                    placement="bottom"
                    trigger="hover"
                    width="350"
                    class="curp"
                  >
                    <span>
                      Know before you go.<br />
                      <br />
                      <strong>Example: </strong> <br />
                      1 - Transfer duration varies depending on traffic and
                      location
                    </span>
                    <div class="badge badge-primary" slot="reference">?</div>
                  </el-popover>
                </h2>
                <div class="row">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-2"
                    v-bind:class="{
                      'invalid-feedback':
                        $v.product.important_information.$error
                    }"
                  >
                    <div
                      class="row"
                      v-for="(item, index) in $v.importantInformation.$each
                        .$iter"
                      :key="index"
                    >
                      <div
                        class="col-xl-11 col-lg-11 col-md-11 col-sm-10 col-11"
                        v-bind:class="{
                          'is-invalid': item.message.$error
                        }"
                      >
                        <el-input
                          v-model="item.message.$model"
                          placeholder="Message"
                          id="message"
                          name="message"
                          tabindex="19"
                          maxlength="160"
                          autofocus
                          type="textarea"
                          :autosize="{
                            minRows: 1,
                            maxRows: 2
                          }"
                        />
                        <div
                          v-if="item.message.$error"
                          class="invalid-feedback"
                        >
                          {{
                            !item.message.minLength || item.message.$error
                              ? `Minimum ${item.message.$params.minLength.min} and Maximum ${item.message.$params.maxLenght.max} characters.`
                              : ""
                          }}
                        </div>
                      </div>

                      <div
                        class="col-xl-1 col-lg-1 col-md-1 col-sm-2 col-12 text-center align-self-center pl-0 "
                        v-if="!item.added.$model"
                      >
                        <base-button
                          type="outline-neutral "
                          class="btn-min"
                          @click="addReasons(item.message, index)"
                        >
                          <i class="flaticon-plus"></i> Add
                        </base-button>
                      </div>

                      <div
                        class="col-xl-1 col-lg-1 col-md-1 col-sm-2 col-1 text-center align-self-center pl-0"
                        v-else
                      >
                        <base-button
                          type="link"
                          class="min-button pl-0"
                          @click="deleteReasons(index)"
                        >
                          <el-tooltip content="Remove" placement="bottom">
                            <span class="icon-action text-danger">
                              <i class="flaticon-cancel"></i>
                            </span>
                          </el-tooltip>
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card pb-4">
                <h2 class="subtitle">
                  Meeting Point
                  <el-popover
                    placement="bottom"
                    trigger="hover"
                    width="350"
                    class="curp"
                  >
                    <span>
                      Instructions to indicate the passenger what to do to
                      easily find their driver. <br />
                      <br />
                      <strong>An example from GG:</strong> <br />
                      Please switch on your mobile phone immediately after
                      landing. Check your SMS messages or Whatsapp/Telegram if
                      you use either of these - your driver may have contacted
                      you here.
                    </span>
                    <div class="badge badge-primary" slot="reference">?</div>
                  </el-popover>
                </h2>
                <div class="row">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-2"
                    v-bind:class="{
                      'invalid-feedback': $v.product.meeting_points.$error
                    }"
                  >
                    <div
                      class="row"
                      v-for="(item, index) in $v.meetingPoints.$each.$iter"
                      :key="index"
                    >
                      <div
                        class="col-xl-11 col-lg-11 col-md-11 col-sm-10 col-11"
                        v-bind:class="{
                          'is-invalid': item.message.$error
                        }"
                      >
                        <el-input
                          v-model="item.message.$model"
                          placeholder="Message"
                          id="message"
                          name="message"
                          tabindex="20"
                          maxlength="160"
                          autofocus
                          type="textarea"
                          :autosize="{
                            minRows: 1,
                            maxRows: 2
                          }"
                        />
                        <div
                          v-if="item.message.$error"
                          class="invalid-feedback"
                        >
                          {{
                            !item.message.minLength || item.message.$error
                              ? `Minimum ${item.message.$params.minLength.min} and Maximum ${item.message.$params.maxLenght.max} characters.`
                              : ""
                          }}
                        </div>
                      </div>

                      <div
                        class="col-xl-1 col-lg-1 col-md-1 col-sm-2 col-12 text-center align-self-center pl-0 "
                        v-if="!item.added.$model"
                      >
                        <base-button
                          type="outline-neutral"
                          class="btn-min"
                          @click="addPoints(item.message, index)"
                        >
                          <i class="flaticon-plus"></i> Add
                        </base-button>
                      </div>

                      <div
                        class="col-xl-1 col-lg-1 col-md-1 col-sm-2 col-1 text-center align-self-center pl-0"
                        v-else
                      >
                        <base-button
                          type="link"
                          class="min-button pl-0"
                          @click="deletePoints(index)"
                        >
                          <el-tooltip content="Remove" placement="bottom">
                            <span class="icon-action text-danger">
                              <i class="flaticon-cancel"></i>
                            </span>
                          </el-tooltip>
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card pb-4">
                <h2 class="subtitle">
                  Additional Information
                  <el-popover
                    placement="bottom"
                    trigger="hover"
                    width="350"
                    class="curp"
                  >
                    <span
                      >Please provide any additional information which applies
                      only to this experience. <br />
                      <strong>Example:</strong> - Not wheelchair accessible
                    </span>
                    <div class="badge badge-primary" slot="reference">?</div>
                  </el-popover>
                </h2>
                <div class="row">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-2"
                    v-bind:class="{
                      'is-invalid': $v.product.additional_information.$error
                    }"
                  >
                    <div
                      class="row"
                      v-for="(item, index) in $v.additionalInformation.$each
                        .$iter"
                      :key="index"
                    >
                      <div
                        class="col-xl-11 col-lg-11 col-md-11 col-sm-10 col-11"
                        v-bind:class="{
                          'is-invalid': item.message.$error
                        }"
                      >
                        <el-input
                          v-model="item.message.$model"
                          placeholder="Message"
                          id="message"
                          name="message"
                          tabindex="20"
                          maxlength="160"
                          type="textarea"
                          :autosize="{
                            minRows: 1,
                            maxRows: 2
                          }"
                          show-word-limit
                        />
                        <div
                          v-if="item.message.$error"
                          class="invalid-feedback"
                        >
                          {{
                            !item.message.minLength || item.message.$error
                              ? `Minimum ${item.message.$params.minLength.min} and Maximum ${item.message.$params.maxLenght.max} characters.`
                              : ""
                          }}
                        </div>
                      </div>

                      <div
                        class="col-xl-1 col-lg-1 col-md-1 col-sm-2 col-12 text-center align-self-center pl-0 "
                        v-if="!item.added.$model"
                      >
                        <base-button
                          type="outline-neutral "
                          class="btn-min"
                          @click="addAdditionalinformation(item.message, index)"
                        >
                          <i class="flaticon-plus"></i> Add
                        </base-button>
                      </div>

                      <div
                        class="col-xl-1 col-lg-1 col-md-1 col-sm-2 col-1 text-center align-self-center pl-0"
                        v-else
                      >
                        <base-button
                          type="link"
                          class="min-button pl-0"
                          @click="deleteAdditionalinformation(index)"
                        >
                          <el-tooltip content="Remove" placement="bottom">
                            <span class="icon-action text-danger">
                              <i class="flaticon-cancel"></i>
                            </span>
                          </el-tooltip>
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="pb-4"
                v-bind:class="{ 'invalid-card': $v.product.images.$error }"
              >
                <div class="mb-2">
                  <UploadImages
                    @uploaderManager="uploaderManager"
                    :images="product.images"
                    :searchCriteria="searchCriteriaImages"
                  ></UploadImages>
                </div>
              </div>
              <small class="invalid-feedback" v-if="$v.product.images.$error"
                >Select or upload 5 pictures</small
              >
            </div>
            <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
              <div
                class="card"
                v-bind:class="{
                  'invalid-card': $v.product.inclusions.$error
                }"
              >
                <h2 class="subtitle">
                  What's Included
                  <el-popover
                    placement="bottom"
                    trigger="hover"
                    width="350"
                    class="curp"
                  >
                    <span>
                      Drag and drop the items from the list to arrange them in
                      the desired order for display in the experience detail.
                      Only the selected items will be shown.
                      <br />
                    </span>
                    <div class="badge badge-primary" slot="reference">?</div>
                  </el-popover>
                </h2>
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 check-expand"
                >
                  <b-form-group v-slot="{ ariaDescribedby }">
                    <b-form-checkbox-group
                      id="product_included"
                      class="intern-box"
                      v-model="selectInclusions"
                      @change="selectNewInclusions"
                      name="product_included"
                      :aria-describedby="ariaDescribedby"
                      tabindex="17"
                    >
                      <draggable
                        :list="inclusions"
                        @change="changeOrderInclusions"
                        ghost-class="ghost"
                        class="row"
                      >
                        <div
                          class="col-xl-12 col-lg-4 col-md-6 col-sm-6 col-12 moving-check"
                          v-for="(item, index) in inclusions"
                          :value="item.value"
                          :label="item.text"
                          :key="index"
                        >
                          <b-form-checkbox :value="`${item.value}`">{{
                            item.text
                          }}</b-form-checkbox>
                        </div>
                      </draggable>
                    </b-form-checkbox-group>
                  </b-form-group>
                </div>
              </div>

              <small
                class="invalid-feedback mb-2"
                v-if="$v.product.inclusions.$error"
                >Select minimum
                {{ $v.product.inclusions.$params.minLength.min }} item</small
              >

              <div
                class="card"
                v-bind:class="{
                  'invalid-card': $v.product.exclusions.$error
                }"
              >
                <h2 class="subtitle">
                  What's not Included
                  <el-popover
                    placement="bottom"
                    trigger="hover"
                    width="350"
                    class="curp"
                  >
                    <span>
                      Drag and drop the items from the list to arrange them in
                      the desired order for display in the experience detail.
                      Only the selected items will be shown.
                    </span>
                    <div class="badge badge-primary" slot="reference">?</div>
                  </el-popover>
                </h2>
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 check-expand"
                  v-bind:class="{
                    'is-invalid': $v.product.exclusions.$error
                  }"
                >
                  <b-form-group v-slot="{ ariaDescribedby3 }">
                    <b-form-checkbox-group
                      id="product_not_included"
                      v-model="selectExclusions"
                      @change="selectNewExclusions"
                      name="product_not_included"
                      :aria-describedby="ariaDescribedby3"
                      tabindex="18"
                    >
                      <draggable
                        :list="exclusions"
                        @change="changeOrderExclusions"
                        ghost-class="ghost"
                        class="row"
                      >
                        <div
                          class="col-xl-12 col-lg-4 col-md-6 col-sm-6 col-12 moving-check"
                          v-for="(item, index) in exclusions"
                          :value="item.value"
                          :label="item.text"
                          :key="index"
                        >
                          <b-form-checkbox :value="`${item.value}`">{{
                            item.text
                          }}</b-form-checkbox>
                        </div>
                      </draggable>
                    </b-form-checkbox-group>
                  </b-form-group>
                </div>
              </div>
              <small
                class="invalid-feedback mb-2"
                v-if="$v.product.exclusions.$error"
                >Select minimum
                {{ $v.product.exclusions.$params.minLength.min }} item</small
              >

              <div class="card">
                <h2 class="subtitle">
                  Tags
                  <el-popover
                    placement="bottom"
                    trigger="hover"
                    width="350"
                    class="curp"
                  >
                    <span>
                      The tags facilitate search, navigation, and help improve
                      the visibility and ranking of experiences in search
                      engines, allowing for increased traffic and sales.
                    </span>
                    <div class="badge badge-primary" slot="reference">?</div>
                  </el-popover>
                </h2>
                <el-select
                  multiple
                  filterable
                  v-model="tags"
                  @change="populateTags"
                  id="tags"
                  name="tags"
                  class="input-custom mb-4"
                >
                  <el-option
                    v-for="(option, index) in tagsOptions"
                    :value="option._id"
                    :label="option.name"
                    :key="index"
                  >
                    <div class="row">
                      <div class="col-lg-8 col-md-8 col-sm-8 col-8">
                        <span class="hide-data">
                          {{ option.name }}
                        </span>
                      </div>
                    </div>
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </tab-pane>
      </tabs>
    </div>

    <div class="container-fluid forms pb-5">
      <div class="alinmov2 mb-3">
        <el-tooltip content="Back" placement="bottom">
          <base-button
            type="neutral"
            class="btn-icon-only"
            @click="goToPreviousPage()"
          >
            <i class="flaticon-left-1"></i>
          </base-button>
        </el-tooltip>

        <base-button
          type="primary"
          class="min-button mb-0"
          @click="saveProduct()"
          v-if="canUserUpdate"
        >
          <i class="flaticon-floppy-disk"></i>Save
        </base-button>
      </div>

      <div>
        <div>
          <CreateBlackoutDate
            :value="openCreateBlackout"
            @onNewBlackout="createBlackout"
            @onCloseNewBlackout="closeCreateBlackout"
          />
          <EditBlackoutDate
            :value="openEditBlackout"
            :index="blackoutIndex"
            :blackout="blackout"
            @onChangeBlackout="changeBlackOut"
            @onCloseEditBlackout="closeEditBlackout"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  ProductsAPI,
  CountriesAPI,
  TagsAPI,
  LocationsAPI
} from "../../../../../core/api";
import flatPicker from "vue-flatpickr-component";
import moment from "moment-timezone";
import lodash from "lodash";
import "flatpickr/dist/flatpickr.css";
import { Switch, Card, DatePicker } from "element-ui";
import Swal from "sweetalert2";
import { VueEditor, Quill } from "vue2-editor";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import CreateBlackoutDate from "../components/CreateBlackoutDates.vue";
import EditBlackoutDate from "../components/EditBlackoutDates.vue";
import draggable from "vuedraggable";
import viewProduct from "../components/ViewProduct.vue";
import LightBox from "vue-image-lightbox";
import "vue-image-lightbox/dist/vue-image-lightbox.min.css";
import {
  required,
  minLength,
  numeric,
  minValue,
  maxLength,
  requiredIf,
  decimal
} from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
import UploadImages from "../components/UploadImages.vue";
import {
  goBack,
  isUserAuthorized,
  setSigOut
} from "../../../../../helpers/commons.helpers";
import { PUBLIC_API_BASE_URL } from "../../../../../core/config/env";
import {
  AVAILABILITY_OPTIONS,
  CURRENCY_COINS,
  CUSTOM_TOOLBAR,
  CUTOFF_OPTIONS,
  DROPZONE_OPTIONS,
  EXCLUSIONS,
  EXPERIENCE_FIELDS,
  INCLUSIONS,
  MIN_SELECT_OPTIONS,
  PRODUCT_TYPES,
  TRANSFERS_OPTIONS
} from "../../../../../core/constants/experiences";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
const validateCategory = value =>
  ["STANDARD", "BUSINESS", "LUXURY"].includes(value);
const validateProductType = value =>
  ["PRIVATE_TRANSFER", "TOUR", "EVENT", "ATTRACTION"].includes(value);
const validateCurrency = value =>
  ["USD", "EUR", "GBP", "CHF", "DKK", "SEK", "NOK", "ISK", "AED"].includes(
    value
  );
const validatePriceType = value => ["PER_PERSON", "UNIT"].includes(value);

export default {
  name: "Product",
  data() {
    return {
      product: {
        name: "",
        code: "",
        service: {
          vehicle: {
            name: "",
            make: "",
            model: "",
            type: "",
            seats: 0
          },
          ref: "",
          category: ""
        },
        quote: "AREA",
        type: "PRIVATE_TRANSFER",
        transfer: {
          type: "ARRIVAL"
        },
        status: false,
        branch: {
          name: "",
          ref: null,
          primary: true
        },
        time_zone: "",
        passengers: {
          minimum: 0,
          maximum: 0
        },
        bags: {
          minimum: 0,
          maximum: 0
        },
        images: [],
        description: "",
        short_description: "",
        currency: {
          code: "USD",
          symbol: "",
          name: ""
        },
        reviews: {
          total: 0,
          rating: 0
        },
        supplier: {
          name: "",
          ref: null
        },
        area: {
          name: "",
          ref: null
        },
        pricing: {
          type: "UNIT",
          amount: 0
        },
        availability: {
          type: "DEFAULT",
          value: []
        },
        cutoff: {
          type: "DEFAULT",
          value: 0,
          unit: "HOURS"
        },
        inclusions: [],
        exclusions: [],
        from: {
          address: "",
          type: "",
          country_code: "",
          location: {
            lat: 0,
            lng: 0
          },
          owner: "",
          place_id: null
        },
        to: {
          address: "",
          type: "",
          country_code: "",
          location: {
            lat: 0,
            lng: 0
          },
          owner: "",
          place_id: null
        },
        meeting_points: [],
        important_information: [],
        destination: {},
        slug: "",
        tags: [],
        additional_information: [],
        cancellation_policy: [],
        duration: {
          value: "",
          unit: "HOURS"
        },
        show_options: false,
        pricing_method: "COMPUTED",
        keyDetails: "",
        termsConditions: ""
      },
      services: [],
      options: [],
      loading: false,
      image: `${PUBLIC_API_BASE_URL}/services/no-preview.png`,
      imageDefault: `${PUBLIC_API_BASE_URL}/services/no-preview.png`,
      availability: AVAILABILITY_OPTIONS,
      cutOffOptios: CUTOFF_OPTIONS,
      productTypes: PRODUCT_TYPES,
      inclusions: INCLUSIONS,
      exclusions: EXCLUSIONS,
      timeZones: [],
      optionsFrom: [],
      optionsTo: [],
      coins: CURRENCY_COINS,
      dropzoneOptions: DROPZONE_OPTIONS,
      productCopy: {},
      leftyProduct: false,
      destinations: [],
      areas: [],
      quote: "AREA",
      importantInformation: [{ message: "", added: false }],
      meetingPoints: [{ message: "", added: false }],
      additionalInformation: [{ message: "", added: false }],
      cancellationPolicy: [{ message: "", added: false }],
      images: [],
      tempUnit: "km",
      setMinimum: "",
      fields: EXPERIENCE_FIELDS,
      openCreateBlackout: false,
      openEditBlackout: false,
      blackoutIndex: -1,
      blackout: {},
      blackouts: [],
      cutOff: 0,
      selectInclusions: [],
      selectExclusions: [],
      tags: [],
      tagsOptions: [],
      customToolbar: CUSTOM_TOOLBAR,
      transfersOptions: TRANSFERS_OPTIONS,
      vatRate: {
        type: "vat",
        value: 0
      },
      originalQuote: null,
      mode: "view",
      searchCriteriaImages: {
        vehicle: {
          make: "",
          model: "",
          type: ""
        },
        destination: {
          slug: "",
          name: ""
        }
      },
      lastSlug: "",
      number_hourly: "",
      minimumSelect: MIN_SELECT_OPTIONS,
      hourlyAvailability: {
        pricePerHour: 0,
        minUnit: 0,
        distanceIncluded: {
          unit: "KM",
          value: 0
        }
      },
      tabActive: "Overview",
      imagesExperiences: [],
      showLightbox: false,
      currentImageIndex: 0,
      disabledMultipleOptions: false
    };
  },
  watch: {
    importantInformation: {
      handler: function(current, old) {
        this.product.important_information = current
          .filter(information => information.added)
          .map(information => information.message);
      },
      deep: true
    },
    meetingPoints: {
      handler: function(current, old) {
        this.product.meeting_points = current
          .filter(meetingPoint => meetingPoint.added)
          .map(meetingPoint => meetingPoint.message);
      },
      deep: true
    },
    additionalInformation: {
      handler: function(current, old) {
        this.product.additional_information = current
          .filter(information => information.added)
          .map(information => information.message);
      },
      deep: true
    },
    cancellationPolicy: {
      handler: function(current, old) {
        this.product.cancellation_policy = current
          .filter(cancellation => cancellation.added)
          .map(cancellation => cancellation.message);
      },
      deep: true
    }
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "RhomTrip Experiences",
        to: "/experiences/rhomtrip"
      },
      {
        text: "Experience Details",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.mode = this.$route.query.mode ? this.$route.query.mode : "view";

    this.productId = this.$route.params.id;
    await this.getProduct(this.productId);
    this.imagesExperiences = this.getNewPicturesFormat(this.product.images);
  },
  methods: {
    async getProduct(productId) {
      try {
        this.setLoad(true);
        let { data } = await ProductsAPI.getProductById(
          productId,
          this.sesion.token
        );
        if (data.status) {
          let product = data.data;
          this.product.name = product.name;
          this.$v.product.name.$model = product.name;
          this.product.code = product.code;
          this.product.quote = product.quote;
          this.quote = product.quote;
          this.product.service.ref = product.service.ref;
          this.product.service.category = product.service.category;
          this.product.service.vehicle.name = product.service.vehicle.name;
          this.product.service.vehicle.make = product.service.vehicle.make;
          this.product.service.vehicle.model = product.service.vehicle.model;
          this.product.service.vehicle.type = product.service.vehicle.type;
          this.product.service.vehicle.seats = product.service.vehicle.seats;
          this.services = [
            {
              vehicle: {
                name: product.service.vehicle.name,
                make: product.service.vehicle.make,
                model: product.service.vehicle.model,
                type: product.service.vehicle.type,
                seats: product.service.vehicle.seats
              },
              _id: product.service.ref
            }
          ];

          this.product.type = product.type;
          this.product.transfer.type = product.transfer.type;
          this.product.status = product.status;
          this.product.branch.name = product.branch.name;
          this.product.branch.ref = product.branch.ref;
          this.product.destination = product.destination;
          this.destinations = [
            {
              name: product.branch.name,
              _id: product.branch.ref,
              supplier: {
                name: product.supplier.name
              },
              destination: product.destination
            }
          ];
          this.product.branch.primary = product.branch.primary;
          this.product.time_zone = product.time_zone;

          this.product.passengers.minimum = product.passengers.minimum;
          this.product.passengers.maximum = product.passengers.maximum;

          this.product.bags.minimum = product.bags.minimum;
          this.product.bags.maximum = product.bags.maximum;
          this.product.images = product.images;
          this.product.description = product.description;
          this.product.short_description = product.short_description;

          this.product.currency.code = product.currency.code;
          this.product.currency.symbol = product.currency.symbol;
          this.product.currency.name = product.currency.name;

          this.product.reviews.total = product.reviews.total;
          this.product.reviews.rating = product.reviews.rating;

          this.product.supplier.name = product.supplier.name;
          this.product.supplier.ref = product.supplier.ref;
          this.areas = [
            {
              _id: product.area.ref,
              code: product.area.name,
              price: product.pricing.amount
            }
          ];
          this.product.area.name = product.area.name;
          this.product.area.ref = product.area.ref;

          this.product.pricing.type = product.pricing.type;
          this.product.pricing.amount = product.pricing.amount;

          this.product.availability.type = product.availability.type;
          this.blackouts = product.availability.value;
          this.product.availability.value = product.availability.value;
          this.product.cutoff.type = product.cutoff.type;
          this.cutOff = product.cutoff.value;
          this.product.cutoff.value = product.cutoff.value;
          this.product.cutoff.unit = product.cutoff.unit;
          this.product.duration.value = product.duration.value;
          this.product.duration.unit = product.duration.unit;
          this.product.show_options = product.show_options;
          this.product.pricing_method = product.pricing_method;
          if (this.product.pricing_method === "FIXED") {
            this.disabledMultipleOptions = true;
          }
          this.product.inclusions = product.inclusions;
          this.inclusions = this.populateFeatures(
            this.product.inclusions,
            this.inclusions
          );
          this.selectInclusions = product.inclusions;

          this.product.exclusions = product.exclusions;
          this.exclusions = this.populateFeatures(
            this.product.exclusions,
            this.exclusions
          );
          this.selectExclusions = product.exclusions;

          this.optionsFrom = product.from.address
            ? [{ select: product.from.address, type: product.from.type }]
            : [];
          this.product.from.address = product.from.address;
          this.product.from.type = product.from.type;

          this.product.from.country_code = product.from.country_code;
          this.product.from.location = product.from.location;
          this.product.from.owner = product.from.owner;
          this.product.from.place_id = product.from.place_id;

          this.optionsTo = product.to.address
            ? [{ select: product.to.address, type: product.to.type }]
            : [];
          this.product.to.address = product.to.address;
          this.product.to.type = product.to.type;

          this.product.to.country_code = product.to.country_code;
          this.product.to.location = product.to.location;
          this.product.to.owner = product.to.owner;
          this.product.to.place_id = product.to.place_id;

          this.product.meeting_points = product.meeting_points;
          this.product.important_information = product.important_information;
          this.product.additional_information = product.additional_information;
          this.product.cancellation_policy = product.cancellation_policy;
          this.product.keyDetails = product.keyDetails;
          this.product.termsConditions = product.termsConditions;
          this.product.slug = product.slug
            ? product.slug
            : this.createSlug(product.name);
          this.lastSlug = this.product.slug;
          this.tagsOptions = await this.getTagsOptions();
          this.product.tags = product.tags.map(tag => {
            return {
              ref: tag.ref,
              name: tag.name,
              slug: tag.slug
            };
          });

          this.tags = this.product.tags.map(tag => tag.ref);

          this.meetingPoints = this.product.meeting_points.map(information => {
            return {
              message: information,
              added: true
            };
          });
          this.meetingPoints.push({ message: "", added: false });

          this.importantInformation = this.product.important_information.map(
            information => {
              return {
                message: information,
                added: true
              };
            }
          );
          this.importantInformation.push({ message: "", added: false });

          this.cancellationPolicy = this.product.cancellation_policy.map(
            information => {
              return {
                message: information,
                added: true
              };
            }
          );
          this.cancellationPolicy.push({ message: "", added: false });

          this.additionalInformation = this.product.additional_information.map(
            information => {
              return {
                message: information,
                added: true
              };
            }
          );
          this.additionalInformation.push({ message: "", added: false });
          await this.getProductPricesByDestinationsId(this.product.branch.ref);
          this.originalQuote = lodash.cloneDeep(
            this.getOriginalQuote(
              this.quote,
              this.product,
              this.destinations,
              this.areas,
              this.services
            )
          );
          this.searchCriteriaImages.destination.slug = product.destination.slug;
          this.searchCriteriaImages.destination.name = product.destination.city;

          this.searchCriteriaImages.vehicle = {
            make: product.service.vehicle.make,
            model: product.service.vehicle.model,
            type: product.service.vehicle.type
          };
          this.productCopy = lodash.cloneDeep(this.product);
          this.setLoad(false);
        } else {
          this.setLoad(false);
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async updateProduct(productId, product, route) {
      try {
        this.setLoad(true);
        let { data } = await ProductsAPI.updateProductById(
          productId,
          product,
          this.sesion.token
        );
        this.setLoad(false);
        this.leftyProduct = true;
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The experience has been Saved",
            icon: "flaticon-check-mark"
          });
          if (route) {
            this.$router.push(route);
          } else {
            this.mode = "view";
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.leftyProduct = true;
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    async saveProduct(route = null) {
      if (!this.$v.product.$invalid) {
        let product = lodash.cloneDeep(this.product);
        await this.updateProduct(this.productId, product, route);
      } else {
        this.$v.importantInformation.$touch();
        this.$v.meetingPoints.$touch();
        this.$v.product.$touch();
        let { overviwe, content } = this.validateProduct(this.$v.product);
        this.goToTab(overviwe, content);
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    getIcon(type) {
      if (type === "airport") {
        return "flaticon-bold-plane";
      } else if (type === "lodging") {
        return "flaticon-bold-bed";
      } else if (type === "point_of_interest") {
        return "flaticon-bold-map";
      } else if (type === "route") {
        return "flaticon-bold-distance";
      } else if (type === "train_station" && type === "transit_station") {
        return "flaticon-bold-train";
      } else {
        return "flaticon-bold-map";
      }
    },
    async getRatesWithTheDestination(branchName) {
      try {
        let { data } = await ProductsAPI.getProductPrices(
          this.quote,
          { branchName: branchName },
          this.sesion.token
        );
        if (data.status) {
          this.destinations = data.data;
        } else {
          this.destinations = [];
        }
      } catch (error) {
        this.destinations = [];
      }
    },
    async getRatesWithTheFromAndTo(from, to) {
      try {
        let { data } = await ProductsAPI.getProductPrices(
          this.quote,
          { from: from, to: to },
          this.sesion.token
        );
        if (data.status) {
          this.destinations = data.data || [];
          this.services = this.destinations
            .map(destination => destination.rates)
            .flat();
        } else {
          this.services = [];
        }
      } catch (error) {
        this.services = [];
      }
    },
    async selectDestination(branchId) {
      try {
        let destination = this.destinations.find(
          destination => destination._id === branchId
        );
        if (destination) {
          this.product.branch.name = destination.name;
          this.product.time_zone = destination.time_zone;
          this.product.destination = destination.destination;
          this.product.supplier.name = destination.supplier.name;
          this.product.supplier.ref = destination.supplier._id;
          this.vatRate = destination.supplier.fee;
          this.services = destination.rates;
          this.product.service.ref = "";
          this.searchCriteriaImages.destination.slug = this.product.destination.slug;
          this.searchCriteriaImages.destination.name = this.product.destination.city;
        } else {
          this.product.branch.name = "";
          this.product.time_zone = "";
          this.product.destination = null;
          this.product.supplier.name = "";
          this.product.supplier.ref = "";
          this.services = [];
          this.product.service.ref = "";
          this.vatRate = {
            type: "vat",
            value: 0
          };
          this.searchCriteriaImages.destination.slug = "";
          this.searchCriteriaImages.destination.name = "";
        }
      } catch (error) {
        this.product.branch.name = "";
        this.product.time_zone = "";
        this.product.destination = null;
        this.product.supplier.name = "";
        this.product.supplier.ref = "";
        this.services = [];
        this.product.service.ref = "";
        this.vatRate = {
          type: "vat",
          value: 0
        };
        this.searchCriteriaImages.destination.slug = "";
        this.searchCriteriaImages.destination.name = "";
      }
    },
    selectServicesType(serviceId) {
      try {
        let service = this.services.find(service => service._id === serviceId);
        if (service) {
          if (this.quote !== "AREA") {
            let destination = this.getDestination(serviceId);
            this.product.branch.ref = destination._id;
            this.product.branch.name = destination.name;
            this.product.destination = destination.destination;
            this.product.time_zone = destination.time_zone;
            this.product.supplier.name = destination.supplier.name;
            this.product.supplier.ref = destination.supplier._id;
            this.vatRate = destination.supplier.fee;
          }
          this.product.area.ref = "";
          this.product.keyDetails = service.keyDetails;
          this.product.termsConditions = service.termsConditions;
          this.product.currency.code = service.currency.code;
          this.product.currency.name = service.currency.name;
          this.product.currency.symbol = service.currency.symbol;
          this.product.passengers.maximum = service.vehicle.seats;
          this.product.bags.maximum = service.vehicle.suitcases;

          this.product.service.vehicle.name = service.vehicle.name;
          this.product.service.vehicle.make = service.vehicle.make;
          this.product.service.vehicle.model = service.vehicle.model;
          this.product.service.vehicle.type = service.vehicle.type;
          this.product.service.vehicle.seats = service.vehicle.seats;
          this.hourlyAvailability = service.hourlyAvailability;
          this.cutOff = service.advancedReservation.cutoff;
          this.product.cutoff.value =
            this.product.cutoff.type === "DEFAULT"
              ? service.advancedReservation.cutoff
              : 0;
          this.product.service.category = this.getCategory(
            service.vehicle.category
          );
          this.areas = service.areas;
          this.blackouts = this.getBlackouts(
            this.product.availability.type,
            service.blackouts
          );
          this.product.availability.value = this.blackouts;
          this.searchCriteriaImages.vehicle = {
            make: service.vehicle.make,
            model: service.vehicle.model,
            type: service.vehicle.type
          };
          let descriptions = service.cancellationPolicy.descriptions || [];
          if (descriptions.length) {
            this.cancellationPolicy = descriptions.map(description => {
              return { message: description, added: true };
            });
            this.cancellationPolicy.push({ message: "", added: false });
          }
        } else {
          if (this.quote !== "AREA") {
            this.product.branch.ref = "";
            this.product.branch.name = "";
            this.product.destination = null;
            this.product.time_zone = "";
            this.product.supplier.name = "";
            this.product.supplier.ref = "";
            this.vatRate = {
              type: "vat",
              value: 0
            };
          }
          this.product.area.ref = "";
          this.product.keyDetails = "";
          this.product.termsConditions = "";
          this.product.currency.code = "";
          this.product.currency.name = "";
          this.product.currency.symbol = "";
          this.product.passengers.maximum = 0;
          this.product.bags.maximum = 0;
          this.product.service.category = "";
          this.product.service.vehicle.name = "";
          this.product.service.vehicle.make = "";
          this.product.service.vehicle.model = "";
          this.product.service.vehicle.type = "";
          this.product.service.vehicle.seats = 0;
          this.cutOff = 0;
          this.product.cutoff.value = 0;
          this.areas = [];
          this.blackouts = [];
          this.product.availability.value = [];
          this.searchCriteriaImages.vehicle = {
            make: "",
            model: "",
            type: ""
          };
        }
      } catch (error) {
        if (this.quote !== "AREA") {
          this.product.branch.ref = "";
          this.product.branch.name = "";
          this.product.destination = null;
          this.product.time_zone = "";
          this.product.supplier.name = "";
          this.product.supplier.ref = "";
          this.vatRate = {
            type: "vat",
            value: 0
          };
        }
        this.product.area.ref = "";
        this.product.keyDetails = "";
        this.product.termsConditions = "";
        this.product.currency.code = "";
        this.product.currency.name = "";
        this.product.currency.symbol = "";
        this.product.passengers.maximum = 0;
        this.product.bags.maximum = 0;
        this.product.service.category = "";
        this.product.service.vehicle.name = "";
        this.product.service.vehicle.make = "";
        this.product.service.vehicle.model = "";
        this.product.service.vehicle.type = "";
        this.product.service.vehicle.seats = 0;
        this.cutOff = 0;
        this.product.cutoff.value = 0;
        this.areas = [];
        this.blackouts = [];
        this.product.availability.value = [];
        this.searchCriteriaImages.vehicle = {
          make: "",
          model: "",
          type: ""
        };
      }
    },
    selectArea(areaId) {
      try {
        let area = this.areas.find(area => area._id === areaId);
        if (area) {
          if (this.product.type !== "TOUR") {
            if (this.product.pricing_method === "COMPUTED") {
              this.product.pricing.amount = this.getTotalAmountByArea(
                area.price,
                this.product.transfer.type,
                this.vatRate.value
              );
            }
          } else {
            if (!this.$v.product.duration.value.$error) {
              if (this.product.pricing_method === "COMPUTED") {
                let price =
                  this.hourlyAvailability.pricePerHour *
                  this.product.duration.value;
                this.product.pricing.amount = this.getTotalAmountByHourlyAvailability(
                  price,
                  this.vatRate.value
                );
              }
            } else {
              this.$notify({
                type: "warning",
                title: "Important!",
                message: "Please Select the duration tour",
                icon: "flaticon-warning-1"
              });
            }
          }
          this.product.area.name = area.code;
        } else {
          this.product.pricing.amount = 0;
          this.product.area.name = "";
        }
      } catch (error) {
        this.product.pricing.amount = 0;
        this.product.area.name = "";
      }
    },
    getTypeLocation(type, origin) {
      if (type === "ARRIVAL" && origin === "from") {
        return "airport";
      } else if (type === "DEPARTURE" && origin === "to") {
        return "airport";
      } else {
        return "point_of_interest";
      }
    },
    async getLocationFrom(input) {
      try {
        if (input !== "" && input.length > 2) {
          let type = this.getTypeLocation(this.product.transfer.type, "from");
          this.loading = true;
          let { data } = await CountriesAPI.autocompleteLocations(input, type);
          this.loading = false;
          if (data.code === 200) {
            let locations = data.data;
            this.optionsFrom = locations;
          } else {
            this.optionsFrom = [];
          }
        } else {
          this.optionsFrom = [];
        }
      } catch (error) {
        this.optionsFrom = [];
      }
    },
    async getLocationTo(input) {
      try {
        if (input !== "" && input.length > 2) {
          let type = this.getTypeLocation(this.product.transfer.type, "to");
          this.loading = true;
          let { data } = await CountriesAPI.autocompleteLocations(input, type);
          this.loading = false;
          if (data.code === 200) {
            let locations = data.data;
            this.optionsTo = locations;
          } else {
            this.optionsTo = [];
          }
        } else {
          this.optionsTo = [];
        }
      } catch (error) {
        this.loading = false;
        this.optionsTo = [];
      }
    },
    async selectFrom(value) {
      try {
        let address = this.optionsFrom.find(
          element => element.select === value
        );
        let place = await this.getPlaceDetails(address);
        this.product.from.type = address ? address.type : "";
        this.product.from.country_code = place ? place.country_code : "";
        this.product.from.location = place
          ? place.location
          : { lat: 0, lng: 0 };
        this.product.from.owner = address ? address.owner : "";
        this.product.from.place_id = address ? address.place_id : "";
        if (
          value !== "" &&
          this.product.to.address !== "" &&
          this.quote === "POINTS"
        ) {
          await this.getRatesWithTheFromAndTo(value, this.product.to.address);
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async selectTo(value) {
      try {
        let address = this.optionsTo.find(element => element.select === value);
        let place = await this.getPlaceDetails(address);
        this.product.to.type = address ? address.type : "";
        this.product.to.country_code = place ? place.country_code : "";
        this.product.to.location = place ? place.location : { lat: 0, lng: 0 };
        this.product.to.owner = address ? address.owner : "";
        this.product.to.place_id = address ? address.place_id : "";
        if (
          value !== "" &&
          this.product.from.address !== "" &&
          this.quote === "POINTS"
        ) {
          await this.getRatesWithTheFromAndTo(value, this.product.from.address);
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    getDestination(serviceId) {
      return this.destinations.find(destination => {
        let service = destination.rates.find(
          service => service._id === serviceId
        );
        return service ? true : false;
      });
    },
    selectTypeQuote(type) {
      let isSame = this.originalQuote.type === type;
      this.product.quote = type;

      this.destinations = isSame ? this.originalQuote.destinations : [];
      this.areas = isSame ? this.originalQuote.areas : [];
      this.services = isSame ? this.originalQuote.services : [];

      this.product.branch.ref = isSame ? this.originalQuote.branchRef : "";
      this.product.branch.name = isSame ? this.originalQuote.branchName : "";

      this.product.supplier.name = isSame
        ? this.originalQuote.supplierName
        : "";
      this.product.supplier.ref = isSame ? this.originalQuote.supplierRef : "";

      this.product.service.ref = isSame ? this.originalQuote.serviceRef : "";

      this.product.area.ref = isSame ? this.originalQuote.areaRef : "";
      this.product.area.name = isSame ? this.originalQuote.areaName : "";

      this.product.from.address = isSame ? this.originalQuote.from.address : "";
      this.product.from.type = isSame ? this.originalQuote.from.type : "";
      this.product.from.country_code = isSame
        ? this.originalQuote.from.country_code
        : "";
      this.product.from.location.lat = isSame
        ? this.originalQuote.from.location.lat
        : 0;
      this.product.from.location.lng = isSame
        ? this.originalQuote.from.location.lng
        : 0;
      this.product.from.owner = isSame ? this.originalQuote.from.owner : "";
      this.product.from.place_id = isSame
        ? this.originalQuote.from.place_id
        : null;

      this.product.to.address = isSame ? this.originalQuote.to.address : "";
      this.product.to.type = isSame ? this.originalQuote.to.type : "";
      this.product.to.country_code = isSame
        ? this.originalQuote.to.country_code
        : "";
      this.product.to.location.lat = isSame
        ? this.originalQuote.to.location.lat
        : 0;
      this.product.to.location.lng = isSame
        ? this.originalQuote.to.location.lng
        : 0;
      this.product.to.owner = isSame ? this.originalQuote.to.owner : "";
      this.product.to.place_id = isSame ? this.originalQuote.to.place_id : null;

      this.product.destination = isSame ? this.originalQuote.destination : null;

      this.vatRate = {
        type: "vat",
        value: 0
      };
    },
    getCategory(type) {
      if (type === "standard") {
        return "STANDARD";
      } else if (type === "business") {
        return "BUSINESS";
      } else {
        return "LUXURY";
      }
    },
    addReasons(message, index) {
      if (!message.$invalid && message.$model) {
        this.importantInformation[index].added = true;
        this.importantInformation.push({ message: "", added: false });
      } else {
        message.$touch();
      }
    },
    deleteReasons(index) {
      this.importantInformation.splice(index, 1);
    },
    addPoints(message, index) {
      if (!message.$invalid && message.$model) {
        this.meetingPoints[index].added = true;
        this.meetingPoints.push({ message: "", added: false });
      } else {
        message.$touch();
      }
    },
    deletePoints(index) {
      this.meetingPoints.splice(index, 1);
    },
    updateBlackout(index, blackout) {
      this.blackoutIndex = index;
      this.openEditBlackout = true;
      this.blackout = {
        name: blackout.name,
        status: blackout.status,
        from: moment(blackout.from)
          .utc(false)
          .format("YYYY-MM-DD"),
        end: moment(blackout.end)
          .utc(false)
          .format("YYYY-MM-DD"),
        description: blackout.description
      };
    },
    changeBlackOut(payload) {
      try {
        let { index, blackout } = payload;
        if (blackout) {
          this.product.availability.value.splice(index, 1, blackout);
          this.openEditBlackout = false;
          this.blackout = {};
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Blackout Date has been updated successfully",
            icon: "flaticon-check-mark"
          });
        } else {
          this.blackout = null;
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Blackout Date cannot be updated",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could't be completed. Please, try again",
          icon: "flaticon-remove"
        });
      }
    },
    closeEditBlackout(status) {
      this.openEditBlackout = !status;
    },
    closeCreateBlackout(status) {
      this.openCreateBlackout = !status;
    },
    addNewBlackout() {
      if (this.product.availability.value.length < 10) {
        this.openCreateBlackout = true;
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "You have exceeded the maximum number of Blackout Date which is 10.",
          icon: "flaticon-warning-1"
        });
      }
    },
    createBlackout(blackout) {
      try {
        if (blackout) {
          this.product.availability.value.push(blackout);
          this.openCreateBlackout = false;
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Blackout Date can't be created",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could't be completed. Please, try again",
          icon: "flaticon-remove"
        });
      }
    },
    async changeStatusByIndex(index, status) {
      let { value } = await Swal.fire({
        title: "Change Status Blackout Date",
        html:
          "Are you sure you want to <strong>Change Status</strong> of the selected Blackout Date?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        this.product.availability.value[index].status = status;
      }
    },
    async deleteBlackoutDate(index) {
      let { value } = await Swal.fire({
        title: "Delete Blackout Date",
        html:
          "Are you sure you want to <strong>Delete</strong> the selected Blackout Date?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",
        confirmButtonClass: "btn btn-primary btn-small-one"
      });
      if (value) {
        await this.deleteBlackOutByIndex(index);
      }
    },
    async deleteBlackOutByIndex(index) {
      try {
        if (index > -1) {
          this.product.availability.value.splice(index, 1);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Blackout Date has been deleted successfully",
            icon: "flaticon-remove"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Blackout Date can't be deleted",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    selectCutoff(value) {
      if (value === "UNRESTRICRED") {
        this.product.cutoff.value = 0;
      } else {
        this.product.cutoff.value = this.cutOff;
      }
    },
    selectAvailability(value) {
      if (value === "UNRESTRICRED") {
        this.product.availability.value = [];
      } else {
        this.product.availability.value = this.blackouts;
      }
    },
    isInProductModule(modules = []) {
      if (!modules.includes("experiences")) {
        this.setProductSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    async detectChanges(to, from, next) {
      let isEqual = lodash.isEqual(this.product, this.productCopy);
      if (!isEqual && !this.leftyProduct && this.canUserUpdate) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The experience has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveProduct(to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    populateFeatures(items = [], features = []) {
      return items
        .map(item => {
          return features.find(element => element.value === item);
        })
        .filter(item => item)
        .concat(
          features.filter(item => {
            return !(items.indexOf(item.value) > -1);
          })
        );
    },
    getFeatures(selectFeatures = [], features = []) {
      return features
        .filter(item => {
          return selectFeatures.indexOf(item.value) > -1;
        })
        .map(item => {
          return item.value;
        });
    },
    isInCollections(value, collections = []) {
      return collections.includes(value);
    },
    selectNewInclusions(value) {
      if (value.length) {
        let select = value[value.length - 1];
        if (this.isInCollections(select, this.product.exclusions)) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message:
              "Please don't select the same items on both sections What's Included/Not Included.",
            icon: "flaticon-warning-1"
          });
          this.selectInclusions.pop();
        } else {
          this.product.inclusions = this.getFeatures(value, this.inclusions);
        }
      } else {
        this.product.inclusions = [];
      }
    },
    changeOrderInclusions(value) {
      this.product.inclusions = this.getFeatures(
        this.selectInclusions,
        this.inclusions
      );
    },
    selectNewExclusions(value) {
      if (value.length) {
        let select = value[value.length - 1];
        if (this.isInCollections(select, this.product.inclusions)) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message:
              "Please don't select the same items on both sections What's Included/Not Included.",
            icon: "flaticon-warning-1"
          });
          this.selectExclusions.pop();
        } else {
          this.product.exclusions = this.getFeatures(value, this.exclusions);
        }
      } else {
        this.product.exclusions = [];
      }
    },
    changeOrderExclusions(value) {
      this.product.exclusions = this.getFeatures(
        this.selectExclusions,
        this.exclusions
      );
    },
    async getTagsOptions() {
      try {
        let { data } = await TagsAPI.getTagsOptions(this.sesion.token);
        if (data) {
          return data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    populateTags(tags = []) {
      try {
        this.product.tags = this.tagsOptions
          .filter(tag => {
            return tags.indexOf(tag._id) > -1;
          })
          .map(tag => {
            return {
              ref: tag._id,
              name: tag.name,
              slug: tag.slug
            };
          });
      } catch (error) {
        this.product.tags = [];
      }
    },
    createProductName(name = "") {
      this.product.slug = this.createSlug(name.trim());
    },
    createSlug(name = "") {
      return name
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-");
    },
    async getPlaceDetails(address) {
      if (address.owner === "google") {
        return await this.getPlaceDetailsByPlaceId(address.place_id);
      } else {
        return {
          location: address.location,
          country_code: address.country_code,
          name: address.select
        };
      }
    },
    async getPlaceDetailsByPlaceId(placeId) {
      try {
        let { data } = await LocationsAPI.getPlaceDetailsByPlaceId(placeId);
        if (data.status) {
          return data.data;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    },
    getTotalAmountByHourlyAvailability(price, vatRate) {
      let basePrice = this.calculatePriceWithVAT(price, vatRate);
      return this.formatPrice(basePrice);
    },
    getTotalAmountByArea(price, transferType, vatRate) {
      if (transferType === "ARRIVAL") {
        let basePrice = this.calculatePriceWithVAT(price, vatRate);
        return this.formatPrice(basePrice);
      } else {
        let basePrice = this.calculatePriceWithVAT(price, vatRate);
        return this.formatPrice(basePrice);
      }
    },
    calculatePriceWithVAT(price, vatRate) {
      return parseFloat((price * (1 + vatRate / 100)).toFixed(2));
    },
    formatPrice(price) {
      return parseFloat(price.toFixed(2));
    },
    getOriginalQuote(type, product, destinations, areas, services) {
      return {
        type: type,
        branchRef: product.branch.ref,
        branchName: product.branch.name,
        supplierName: product.supplier.name,
        supplierRef: product.supplier.ref,
        serviceRef: product.service.ref,
        areaRef: product.area.ref,
        areaName: product.area.name,
        from: product.from,
        to: product.to,
        destination: product.destination,
        destinations: destinations,
        areas: areas,
        services: services
      };
    },
    async getProductPricesByDestinationsId(destinationsId) {
      try {
        let { data } = await ProductsAPI.getProductPricesByDestinationsId(
          destinationsId,
          this.sesion.token
        );
        if (data.status) {
          let destination = data.data;
          this.services = destination.rates;
          this.vatRate = destination.supplier.fee;
          this.destinations = [destination];
          let service = this.services.find(
            service => service._id === this.product.service.ref
          );
          if (service) {
            this.areas = service.areas;
            this.hourlyAvailability = service.hourlyAvailability;
          }
        } else {
          this.services = this.services;
          this.areas = this.areas;
          this.vatRate = this.vatRate;
          this.destinations = this.destinations;
        }
      } catch (error) {
        this.services = this.services;
        this.areas = this.areas;
        this.vatRate = this.vatRate;
        this.destinations = this.destinations;
      }
    },
    getBlackouts(type, blackouts = []) {
      if (type === "UNRESTRICRED") {
        return [];
      } else {
        return blackouts.filter(blackout => blackout.status);
      }
    },
    addCancellationPolicy(message, index) {
      if (!message.$invalid && message.$model) {
        this.cancellationPolicy[index].added = true;
        this.cancellationPolicy.push({ message: "", added: false });
      } else {
        message.$touch();
      }
    },
    deleteCancellationPolicy(index) {
      this.cancellationPolicy.splice(index, 1);
    },
    addAdditionalinformation(message, index) {
      if (!message.$invalid && message.$model) {
        this.additionalInformation[index].added = true;
        this.additionalInformation.push({ message: "", added: false });
      } else {
        message.$touch();
      }
    },
    deleteAdditionalinformation(index) {
      this.additionalInformation.splice(index, 1);
    },
    uploaderManager(files = []) {
      this.product.images = lodash.cloneDeep(files);
      this.images = lodash.cloneDeep(files);
    },
    async duplicateProduct(productId) {
      let { value } = await Swal.fire({
        title: "Duplicate experience",
        html:
          "Are you sure you want to <strong>duplicate</strong> this experience?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.duplicateProductIdById(productId, true);
      }
    },
    async duplicateProductIdById(productId, populate) {
      try {
        let { data } = await ProductsAPI.getProductById(
          productId,
          this.sesion.token
        );
        if (data.status) {
          let product = this.removeAttributesThatWillNotBeDuplicated(
            lodash.cloneDeep(data.data)
          );
          this.setDuplicatedProduct(product);
          this.$router.push("/experiences/rhomtrip/new");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    removeAttributesThatWillNotBeDuplicated(product) {
      delete product._id;
      delete product.created_at;
      delete product.updatedAt;
      delete product.title;
      delete product.__v;
      return product;
    },
    goToNewProduct() {
      this.setDuplicatedProduct(null);
      this.$router.push("/experiences/rhomtrip/new");
    },
    async checkProductSlugIsDuplicate(slug) {
      try {
        if (this.lastSlug !== slug) {
          let { data } = await ProductsAPI.checkProductSlugIsDuplicate(
            slug,
            this.sesion.token
          );
          return data.status ? !data.data.isDuplicate : false;
        } else {
          return true;
        }
      } catch (error) {
        return false;
      }
    },
    validationMessageForProductName(name) {
      if (name.$error) {
        if (!name.required) {
          return "Enter Experience title";
        } else if (!name.minLength || !name.maxLenght) {
          return `Minimum ${name.$params.minLength.min} and Maximum ${name.$params.maxLenght.max} characters.`;
        } else if (!name.customValidator) {
          return "Experience title is already used";
        }
      } else {
        return "";
      }
    },
    getDescriptionByAreaId(areaId) {
      let area = this.areas.find(area => area._id === areaId);
      if (area) {
        return area.description;
      } else {
        return "";
      }
    },
    getDateFormat(date, format) {
      return moment
        .parseZone(date)
        .utc(true)
        .format(format);
    },
    getCategoryFormat(type) {
      if (type === "standard") {
        return "Standard Class";
      } else if (type === "business") {
        return "Business Class";
      } else {
        return "Luxury Class";
      }
    },
    getQuoteFormat(value) {
      if (value === "AREA") {
        return "Area";
      } else {
        return "From and To";
      }
    },
    isFromRequired(productType, quote, transferType, value) {
      if (productType === "TOUR") {
        return false;
      } else {
        if (quote === "POINTS") {
          return true;
        } else {
          if (transferType === "ARRIVAL") {
            return true;
          } else if (transferType === "DEPARTURE") {
            return false;
          } else {
            return value ? false : true;
          }
        }
      }
    },
    isToRequired(productType, quote, transferType, value) {
      if (productType === "TOUR") {
        return false;
      } else {
        if (this.quote === "POINTS") {
          return true;
        } else {
          if (this.product.transfer.type === "DEPARTURE") {
            return true;
          } else if (this.product.transfer.type === "ARRIVAL") {
            return false;
          } else {
            return this.product.from.address ? false : true;
          }
        }
      }
    },
    selectHourly(value) {
      if (value) {
        let price = this.hourlyAvailability.pricePerHour * parseFloat(value);
        this.product.pricing.amount = this.getTotalAmountByHourlyAvailability(
          price,
          this.vatRate.value
        );
      }
    },
    selectProductType(type) {
      if (type === "TOUR") {
        this.product.transfer.type = "HOURLY";
      }
    },
    changeTabActive(tabActive) {
      this.tabActive = tabActive;
    },
    getProductType(type) {
      if (type === "EVENTE") {
        return "Event";
      } else if (type === "PRIVATE_TRANSFER") {
        return "Private Transfer";
      } else if (type === "ATTRACTION") {
        return "Attraction";
      } else if (type === "TOUR") {
        return "Tour";
      }
    },
    getBookingType(type) {
      if (type === "AIRPORT") {
        return "Airport Transfer";
      } else if (type === "ARRIVAL") {
        return "Airport (Arrival)";
      } else if (type === "DEPARTURE") {
        return "Airport (Departure)";
      } else if (type === "STATION") {
        return "Station Transfer";
      } else if (type === "PORT") {
        return "Port Transfer";
      } else if (type === "JOURNEY") {
        return "Journey";
      }
    },
    getAvailabilityTypeFormat(type) {
      if (type === "DEFAULT") {
        return "Default";
      } else if (type === "BLACKOUT") {
        return "Blackout Dates";
      } else if (type === "UNRESTRICRED") {
        return "No Restriction";
      }
    },
    getCutOffTypeFormat(type) {
      if (type === "DEFAULT") {
        return "Default";
      } else if (type === "MINIMUM") {
        return "Minimum";
      } else if (type === "UNRESTRICRED") {
        return "No Restriction";
      }
    },
    getQuoteFormat(type) {
      if (type === "AREA") {
        return "Area";
      } else if (type === "POINTS") {
        return "From & To";
      }
    },
    getMultipleFormat(value) {
      return value ? "Yes" : "No";
    },

    openBox(index) {
      this.$refs.lightbox.showImage(index);
      this.currentImageIndex = index;
      this.showLightbox = true;
    },
    getNewPicturesFormat(urls) {
      return urls.map((url, index) => {
        return {
          thumb: url,
          src: url
        };
      });
    },
    formatCategory(type) {
      if (type === "standard") {
        return "Standard Class";
      } else if (type === "business") {
        return "Business Class";
      } else {
        return "Luxury Class";
      }
    },
    formatVehicleType(type) {
      if (type === "sedan") {
        return "Sedan";
      } else if (type === "boat") {
        return "Boat";
      } else if (type === "coach") {
        return "Coach";
      } else if (type === "limousine") {
        return "Limousine";
      } else if (type === "minibus") {
        return "Minibus";
      } else if (type === "midicoach") {
        return "Midicoach";
      } else if (type === "minivan") {
        return "Minivan";
      } else if (type === "mpv") {
        return "Mpv";
      } else if (type === "pickup") {
        return "Pickup";
      } else if (type === "premium_sedans") {
        return "Premium Sedans";
      } else if (type === "suvs") {
        return "SUVs";
      }
    },
    getPricingMethod(pricingMethod) {
      if (pricingMethod === "FIXED") {
        return "Fixed";
      } else {
        return "Computed";
      }
    },
    goToTab(overviwe, content) {
      if (overviwe) {
        this.tabActive = "Overview";
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "Please complete the required attributes in the tab Overview",
          icon: "flaticon-warning-1"
        });
      } else if (content) {
        this.tabActive = "Content";
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes in the tab Content",
          icon: "flaticon-warning-1"
        });
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    validateProduct(product) {
      return {
        overviwe: this.validateOverviwe(product),
        content: this.validateContent(product)
      };
    },
    validateOverviwe(product) {
      return (
        product.name.$invalid ||
        product.service.$invalid ||
        product.type.$invalid ||
        product.transfer.$invalid ||
        product.branch.$invalid ||
        product.status.$invalid ||
        product.area.$invalid ||
        product.pricing.$invalid ||
        product.availability.$invalid ||
        product.cutoff.$invalid ||
        product.from.$invalid ||
        product.to.$invalid ||
        product.destination.$invalid ||
        product.slug.$invalid ||
        product.cancellation_policy.$invalid
      );
    },
    validateContent(product) {
      return (
        product.images.$invalid ||
        product.description.$invalid ||
        product.short_description.$invalid ||
        product.inclusions.$invalid ||
        product.exclusions.$invalid ||
        product.important_information.$invalid ||
        product.meeting_points.$invalid ||
        product.additional_information.$invalid
      );
    },
    changePricingMethod(value) {
      if (value === "FIXED") {
        this.product.show_options = false;
        this.disabledMultipleOptions = true;
      }
    },
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setProductSearchCriteria",
      "setDuplicatedProduct"
    ])
  },
  components: {
    [Switch.name]: Switch,
    [Card.name]: Card,
    [DatePicker.name]: DatePicker,
    flatPicker,
    WSelect,
    VueEditor,
    CreateBlackoutDate: CreateBlackoutDate,
    EditBlackoutDate: EditBlackoutDate,
    draggable,
    Quill,
    viewProduct,
    UploadImages: UploadImages,
    LightBox
  },
  computed: {
    ...mapGetters(["sesion", "userRole", "sigout"]),
    canUserUpdate() {
      return isUserAuthorized("EXPERIENCES", this.userRole, "UPDATE");
    },
    canUserCreate() {
      return isUserAuthorized("EXPERIENCES", this.userRole, "CREATE");
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInProductModule(to.meta.modules);
    this.detectChanges(to, from, next);
  },
  validations: {
    product: {
      name: {
        required,
        minLength: minLength(40),
        maxLenght: maxLength(160),
        customValidator: async function(value) {
          if (value.length >= 40 && value.length <= 160) {
            let slug = this.createSlug(value);
            return await this.checkProductSlugIsDuplicate(slug);
          } else {
            return false;
          }
        }
      },
      service: {
        vehicle: {
          name: {
            required
          }
        },
        ref: {
          required
        },
        category: {
          required,
          validateCategory
        }
      },
      type: {
        required,
        validateProductType
      },
      transfer: {
        type: {
          required: requiredIf(function(value) {
            return this.product.type === "PRIVATE_TRANSFER";
          })
        }
      },
      status: {
        required
      },
      area: {
        name: {
          required,
          minLength: minLength(2),
          maxLenght: maxLength(100)
        },
        ref: {
          required
        }
      },
      branch: {
        name: {
          required,
          minLength: minLength(2),
          maxLenght: maxLength(100)
        },
        ref: {
          required
        },
        primary: {
          required
        }
      },
      time_zone: {
        required,
        minLength: minLength(0),
        maxLenght: maxLength(70)
      },
      passengers: {
        minimum: {
          numeric,
          required
        },
        maximum: {
          numeric,
          required
        }
      },
      bags: {
        minimum: {
          numeric,
          required
        },
        maximum: {
          numeric,
          required
        }
      },
      images: {
        required,
        minLength: minLength(5),
        maxLenght: maxLength(8)
      },
      description: {
        required,
        minLength: minLength(160),
        maxLenght: maxLength(1000)
      },
      short_description: {
        required,
        minLength: minLength(50),
        maxLenght: maxLength(160)
      },
      currency: {
        code: {
          required,
          minLength: minLength(3),
          maxLenght: maxLength(4),
          validateCurrency
        },
        symbol: {
          required,
          maxLenght: maxLength(4)
        },
        name: {
          required,
          minLength: minLength(0),
          maxLenght: maxLength(45)
        }
      },
      reviews: {
        total: {
          numeric
        },
        rating: {
          numeric
        }
      },
      supplier: {
        name: {
          required,
          minLength: minLength(3),
          maxLenght: maxLength(100)
        },
        ref: {
          required
        }
      },
      pricing: {
        type: {
          required,
          minLength: minLength(0),
          maxLenght: maxLength(15),
          validatePriceType
        },
        amount: {
          decimal,
          required,
          minValue: minValue(1)
        }
      },
      inclusions: {
        required,
        minLength: minLength(1),
        maxLenght: maxLength(15)
      },
      exclusions: {
        required,
        minLength: minLength(1),
        maxLenght: maxLength(15)
      },
      availability: {
        type: {
          required: true
        },
        value: {
          required: requiredIf(function(value) {
            return this.product.availability.type === "BLACKOUT";
          })
        }
      },
      cutoff: {
        type: {
          required: true
        },
        value: {
          numeric,
          required: requiredIf(function(value) {
            return this.product.cutoff.type === "MINIMUM";
          })
        }
      },
      from: {
        address: {
          minLength: minLength(0),
          maxLenght: maxLength(200),
          required: requiredIf(function(value) {
            return this.isFromRequired(
              this.product.type,
              this.quote,
              this.product.transfer.type,
              value
            );
          })
        },
        type: {
          required: requiredIf(function(value) {
            return this.isFromRequired(
              this.product.type,
              this.quote,
              this.product.transfer.type,
              value
            );
          })
        }
      },
      to: {
        address: {
          minLength: minLength(0),
          maxLenght: maxLength(200),
          required: requiredIf(function(value) {
            return this.isToRequired(
              this.product.type,
              this.quote,
              this.product.transfer.type,
              value
            );
          })
        },
        type: {
          required: requiredIf(function(value) {
            return this.isToRequired(
              this.product.type,
              this.quote,
              this.product.transfer.type,
              value
            );
          })
        }
      },
      important_information: {
        required,
        minlength: minLength(1),
        maxLenght: maxLength(15)
      },
      meeting_points: {
        required,
        minLength: minLength(1),
        maxLenght: maxLength(15)
      },
      additional_information: {
        minLength: minLength(1),
        maxLenght: maxLength(15)
      },
      cancellation_policy: {
        minLength: minLength(1),
        maxLenght: maxLength(15)
      },
      destination: {
        required
      },
      slug: {
        required
      },
      duration: {
        value: {
          numeric,
          required: requiredIf(function(value) {
            return this.product.type === "TOUR";
          }),
          customValidator: function(value) {
            if (this.product.type === "TOUR") {
              return value > 0;
            } else {
              return true;
            }
          }
        },
        unit: {
          required: requiredIf(function(value) {
            return this.product.type === "TOUR";
          })
        }
      },
      keyDetails: {
        minLength: minLength(10),
        maxLength: maxLength(1500)
      },
      termsConditions: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(2100)
      }
    },
    meetingPoints: {
      $each: {
        message: {
          minLength: minLength(10),
          maxLenght: maxLength(250)
        },
        added: {}
      }
    },
    importantInformation: {
      $each: {
        message: {
          minLength: minLength(10),
          maxLenght: maxLength(250)
        },
        added: {}
      }
    },
    additionalInformation: {
      $each: {
        message: {
          minLength: minLength(10),
          maxLenght: maxLength(250)
        },
        added: {}
      }
    },
    cancellationPolicy: {
      $each: {
        message: {
          minLength: minLength(10),
          maxLenght: maxLength(250)
        },
        added: {}
      }
    },
    setMinimum: {
      numeric,
      required: requiredIf(function(value) {
        return this.product.cutoff == "newMinimum";
      })
    }
  }
};
</script>
